<template>
    <div v-if="dotsLoading" class="mt-2">
		<!-- <div class="flex items-center justify-center w-full"> -->
			<dots-loader/>
		<!-- </div> -->
    </div>
	<div v-else>
		<div :class="modalMode ? 'details-in-modal task-details-in-modal' : 'mb-5 mx-5 mt-3 ResponsiveControlePage'">
			<div class="mb-2" v-if="!modalMode">
				<breadCrumbs :routesArray="routesArray"></breadCrumbs>
			</div>
			<div class="row w-full h-full flex mt-2 justify-between">
					<h1 v-if="!modalMode" class="truncate min-w-0 max-w-[calc(100%-2.5rem)] pr-4">
						{{ presentFindingTaskObj.action != undefined ? presentFindingTaskObj.action : 'N/A' }}
					</h1>
					<div v-else></div>
				<!-- for total task approval -->
				<div class="flex flex-row" v-if="(presentFindingTaskObj.auditor == userInfo._id || userInfo?.role_id!=10216) && (presentFindingTaskObj.statusCode == 10421)">
					<button class="btnprimary items-center mr-2" @click="approveOrRejectForActionTasktoComplete(10403,7)">Approve</button>
					<button class="btnprimary items-center" @click="clickToRejectByJustification()">Reject</button>
				</div>

				<!-- for normal approval -->
				<div class="flex flex-row" v-if="presentFindingTaskObj.approvals && presentFindingTaskObj.approvals.length && presentFindingTaskObj.approvals[presentFindingTaskObj.approvals.length - 1].statusCode== 10401 && presentFindingTaskObj.approvals[presentFindingTaskObj.approvals.length - 1].approver == userInfo._id">
					<button class="btnprimary items-center mr-2" @click="ApprovalforInprogress(10403)">Approve</button>
					<button class="btnprimary items-center" @click="onClickToRejectByJustificationAtInReview()">Reject</button>
				</div>
			</div>
			
			<div class="w-full minheight">
				<div class="w-full">
					<div class="text-sm">
						<div class="mainContainer tabStructure flex flex-row w-full bg-white border rounded-sm mt-5 px-5 pt-5 pb-3 border-lightgrey">
							<div class="w-80 heightFixing pr-5">
								<!-- <div class="tabStructureDiv">
									<div class="flex flex-row borderBottom justify-between cursor-pointer tab-container">
										<div class="pb-1" :class="selectedTabIndex == tab.id ? 'adjust header font-semibold text-primary':'text-sm text-disabledgrey'" v-for="(tab, tabIndex) in tabHead" :key="tabIndex" @click="toggleTabs(tab)">
											<div>
												<div class="cursor-pointer">{{ tab.displayName }}</div>
												<div :class="{ progress: selectedTabIndex == tab.id }" class="h-1 p-0.75"></div>
											</div>
										</div>
									</div>
									<div class="progressbarB rounded h-1"></div>
								</div> -->
								<Tabs  v-model:value="selectedTabIndex" scrollable class="heightFixing">
									<div>
										<TabList>
											<Tab v-for="(tab) in tabHead" :key="tab.id" :value="tab.id" @click="toggleTabs(tab)">
												{{ tab.displayName }}
											</Tab>
										</TabList>
									</div>
									<TabPanels class="overflow-auto hide-scrollbar">
										<TabPanel v-for="(tab) in tabHead" :key="tab.id" :value="tab.id">
											<div v-if="tabDataLoading == true">
												<div class="flex items-center justify-center w-full h-16 skeleton">
												<dots-loader/>
												</div>
											</div>
											<div v-else class="h-full">
												<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 1">
													
													<!-- <div>
														<div class="border-b border-lightgrey">
															<p class="mt-3 mb-2 header">Action</p>
														</div>
														<p class="mt-2 headerText">{{ presentFindingTaskObj.action }}</p>
													</div> -->
													<div>
														<div>
														<div
														class="border-b border-lightgrey flex justify-between mb-3 paddingBottomForFindings"
														>
														<div class="flex items-center justify-center">
															<div>
															<p class="header mt-2.5">Action Information</p>
															</div>
														</div>
														</div>
													</div>
													
													<div class="flex flex-row">
														<div
															class="border-t border-l border-b p-2 header w-23 border-lightgrey rounded-tl-md"
														>
														Cause
														</div>
														<div
															class="border border-lightgrey w-77 p-2 rounded-tr-md text-xs"
														>
															{{ (presentFindingTaskObj.cause != undefined ? presentFindingTaskObj.cause : 'N/A') }}
															
														</div>
														</div>
														<div class="flex flex-row">
														<div
															class="border-l border-b p-2 header w-23 border-lightgrey"
														>
														Action
															
														</div>
														<div
															class="border-r border-b border-l border-lightgrey w-77 text-xs p-2 text-justify"
														>
														{{ (presentFindingTaskObj.action != undefined ? presentFindingTaskObj.action : 'N/A')}}
														</div>
														</div>
														<div>
															<div class="border-b border-lightgrey flex justify-between mb-5 paddingBottomForFindings mt-3">
																<div class="marginBottom1px flex items-center justify-center">
																	<div>
																		<p class="header mt-0.5">Finding Information</p>
																	</div>
																</div>
															</div>
														</div>
													<div v-if="presentFindingObject[0]">
														<!-- <div v-for="(obj, index) in presentFindingObject" :key="index" class="mt-3">{{ obj }} -->
														<div class="flex flex-row">
															<div class="border-t border-l border-b p-2 header w-23 border-lightgrey rounded-tl-md">Finding ID</div>
															<div  class="border header border-lightgrey w-77 p-2 rounded-tr-md text-xs">
																{{presentFindingObject[0].findingId}}
															</div>
														</div>
														<div class="w-full flex flex-row">
															<div class="border-l w-23 border-b p-2 header border-lightgrey">Framework</div>
															<div  class="w-27 border-b border-l border-lightgrey text-xs p-2">
																<div class="mt-1">{{presentFindingObject[0].frameworks}}</div>
															</div>
															<div class="border-l w-23 border-b p-2 header border-lightgrey">Control Number</div>
															<div  class="border-r w-27 border-b border-l border-lightgrey p-2">
																<div class="pl-3 flex items-center flex-wrap">
																	<div :class="getBorder()" class="text-xs px-2 py-0.5 font-opensans bg-white font-bold h-auto w-fit flex items-center" >
																		{{presentFindingObject[0].frameWorkControl}}
																	</div>
																</div>
															</div>
														</div>
														<div class="flex flex-row">
															<div class="border-l border-b p-2 header w-23 border-lightgrey">Control Title</div>
															<div class="border-r border-b border-l border-lightgrey w-77 text-xs p-2">{{ presentFindingObject[0].frameworkControlTitle ? presentFindingObject[0].frameworkControlTitle : 'N/A' }}</div>
														</div>
														<div class="flex flex-row">
															<div class="border-l border-b p-2 header w-23 border-lightgrey">Finding</div> <div  class="border-r border-b border-l border-lightgrey w-77 text-xs p-2 text-justify">{{presentFindingObject[0].findingComment}}</div>
														</div>
														<div class="flex flex-row">
															<div class="border-l border-b p-2 header w-23 border-lightgrey">Finding Severity</div>
															<div class="border-r border-b border-l border-lightgrey w-77 p-2 text-xs flex items-center">
																<div
																	v-if="getFindingSeverityValue(presentFindingObject[0]) != null"
																	class="flex items-center justify-center rounded h-5 w-28 px-2.5 regular whitespace-nowrap overflow-hidden"
																	:class="findingSeverityChipBg(presentFindingObject[0])"
																	:title="getFindingSeverityLabel(presentFindingObject[0])"
																>
																	<div class="truncate whitespace-nowrap" :class="findingSeverityChipText(presentFindingObject[0])">
																		{{ getFindingSeverityLabel(presentFindingObject[0]) }}
																	</div>
																</div>
																<span v-else>N/A</span>
															</div>
														</div>
														<div class="flex flex-row">
															<div
																class="border-l border-b p-2 header w-23 border-lightgrey flex items-center"
															>
																Evidence
															</div>
															<div
																class="border-r border-b border-l border-lightgrey w-77 min-w-0 text-xs p-2 text-justify rounded-br-md"
															>
																<div v-if="findingFileEvidences.length || findingLinkEvidences.length" class="flex gap-3 flex-wrap">
																<div v-for="(doc, idx) in findingFileEvidences" :key="'finding-file-'+idx">
																	<div class="pdf w-full rounded-sm">
																		<a
																			href="#"
																			@click.prevent="openEvidenceFile(doc)"
																			class="flex w-full flex-row items-center cursor-pointer"
																		>
																			<img src="@/assets/doc.svg" alt="" v-if=" getEvidenceFileExt(doc)=='doc'"/>
																			<img src="@/assets/docx.svg" alt="" v-if=" getEvidenceFileExt(doc)=='docx'" />
																			<img src="@/assets/xls.svg" alt="" v-if=" getEvidenceFileExt(doc)=='xls'" />
																			<img src="@/assets/xlsx.svg" alt="" v-if=" getEvidenceFileExt(doc)=='xlsx'" />
																			<img src="@/assets/pdf.svg" alt="" v-if=" getEvidenceFileExt(doc)=='rtf'"/>
																			<img src="@/assets/txt.svg" alt="" v-if=" getEvidenceFileExt(doc)=='txt'"/>
																			<img src="@/assets/png.svg" alt="" v-if=" getEvidenceFileExt(doc)=='png'"/>
																			<img src="@/assets/jpg.svg" alt="" v-if=" getEvidenceFileExt(doc)=='jpg'"/>
																			<img src="@/assets/jpeg.svg" alt="" v-if=" getEvidenceFileExt(doc)=='jpeg'"/>
																			<img src="@/assets/csv.svg" alt="" v-if=" getEvidenceFileExt(doc)=='csv'"/>
																			<img src="@/assets/zip.svg" alt="" v-if=" getEvidenceFileExt(doc)=='zip'"/>
																			<img src="@/assets/mp4.svg" alt="" v-if=" getEvidenceFileExt(doc)=='mp4'"/>
																			<img src="@/assets/pdf.svg" alt="" v-if=" getEvidenceFileExt(doc)=='pdf'" />
																			<div class="flex flex-col w-full min-w-0">
																				<div class="ml-2 pb-1">
																				<p class="text-xs font-medium truncate" :title="doc.filename || doc.name">{{doc.filename || doc.name || 'N/A'}}</p>
																				</div>
																				<div class="flex justify-between w-full">
																				<p class="ml-2 fontSize10PX">{{doc.evidenceDate?formatFileAttachedTime(doc.evidenceDate):'N/A'}}</p>
																				<p class="mr-2 fontSize10PX font-semibold">{{doc.taskId?doc.taskId:'N/A'}}</p>
																				</div>
																			</div>
																		</a>
																	</div>
																</div>
																<div v-for="(doc, idx) in findingLinkEvidences" :key="'finding-link-'+idx">
																	<div class="pdf w-full rounded-sm">
																		<a
																			href="#"
																			@click.prevent="openEvidenceFile(doc)"
																			class="flex w-full flex-row items-center cursor-pointer finding-evidence-link-icon"
																			:aria-label="doc.url"
																		>
																			<span class="finding-evidence-link-icon__img-wrap">
																				<img src="@/assets/link.svg" alt="Link" class="finding-evidence-link-icon__img" />
																				<span class="finding-evidence-link-icon__tooltip">{{ doc.url }}</span>
																			</span>
																			<div class="flex flex-col w-full min-w-0">
																				<div class="ml-2 pb-1">
																					<p class="text-xs font-medium truncate" :title="doc.filename || doc.name">{{doc.filename || doc.name || 'N/A'}}</p>
																				</div>
																				<div class="flex justify-between w-full">
																					<p class="ml-2 fontSize10PX">{{doc.evidenceDate?formatFileAttachedTime(doc.evidenceDate):'N/A'}}</p>
																					<p class="mr-2 fontSize10PX font-semibold">{{doc.taskId?doc.taskId:'N/A'}}</p>
																				</div>
																			</div>
																		</a>
																	</div>
																</div>
																</div>
																<div v-else>{{ presentFindingObject[0].findingEvidence}}</div>
															</div>
															
														</div>
														<div class="w-full flex flex-row">
															<div class="border-l w-23 border-b p-2 header border-lightgrey rounded-bl-md">Finding Category</div>
															<div  class="w-27 border-b border-l border-lightgrey  p-2">
																	<div v-if="presentFindingObject[0].findingCategory === 1" class="flex items-center justify-center rounded w-28 h-5 text-error bg-highColor border-solid border text-xs border-error p-1 font-semibold">{{getCategory(presentFindingObject[0].findingCategory)}}</div>
																	<div v-if="presentFindingObject[0].findingCategory === 2" class="flex items-center justify-center rounded w-28 h-5 text-darkred bg-veryHighColor border-solid border text-xs border-darkred p-1 font-semibold">{{getCategory(presentFindingObject[0].findingCategory)}}</div>
																	<div v-if="presentFindingObject[0].findingCategory === 3" class="flex items-center justify-center rounded w-28 h-5 text-lightgreen bg-veryLowColor border-solid border text-xs border-lightgreen p-1 font-semibold">{{getCategory(presentFindingObject[0].findingCategory)}}</div>
																	<div v-if="presentFindingObject[0].findingCategory === 4" class="flex items-center justify-center rounded w-28 h-5 text-yellow bg-moderateColor border-solid border text-xs border-yellow p-1 font-semibold">{{getCategory(presentFindingObject[0].findingCategory)}}</div>
																</div>
																<div class="border-l w-23 border-b p-2 header border-lightgrey">Control Audit Result</div>
																<div class="border-r w-27 border-b border-l border-lightgrey p-2 rounded-br-md">
																	<div v-if="presentFindingObject[0].auditResult === 'Pass'" class="flex items-center justify-center rounded h-5 w-28 text-lightgreen bg-veryLowColor border-solid text-xs border border-lightgreen font-semibold">{{presentFindingObject[0].auditResult}}</div>
																	<div v-if="presentFindingObject[0].auditResult === 'Fail'" class="flex items-center justify-center rounded h-5 w-28 text-darkred bg-veryHighColor border-solid text-xs border border-darkred font-semibold">{{presentFindingObject[0].auditResult}}</div>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 2">
													<div>
														<div class="border-b border-lightgrey flex justify-between pb-2 mt-3">
															<div class="flex items-center mt-0.5 marginTopForDoc marginBottomForDoc justify-center">
																<div>
																	<p class="header">Documents which are related to the controls</p>
																</div>
															</div>
														</div>
														<!-- <p class="mt-1.5">{{ descriptionObject._id }}</p> -->
													</div>
												</div>
												<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 3">
													<div>
														<!-- <div class="border-b border-lightgrey">
															<div class="flex justify-between mb-1.5">
																<div class="header flex justify-center items-center">Files </div>
																<div class="buttonposition flex justify-center items-center">
																	<input  type="file" id="upload" ref="element"/>
																	<button class="btnprimary w-24 flex justify-center taskEditButtons">Attach</button> 
																	<button @click="openFilePicker" for="upload" class="btnprimary w-24 flex justify-center taskEditButtons">Attach</button>
																	<input type="file" ref="fileInput" id="upload" @change.stop="handleFileChange" style="display: none" />
																</div>
															</div>
														</div> -->
														<div class="evidence-tab-content">
														<div class="evidence-files-block">
														<div class="border-b border-lightgrey flex justify-between items-center pb-2 mt-3">
															<div class="flex items-center justify-center">
																<p class="header">Files</p>
															</div>
															<div class="buttonposition flex justify-center items-center gap-2">
																<button @click="openLinkEvidencePopup" :class="isEvidenceAttachDisabled() ? 'btndisabled pointer-events-none' : 'filterButton flex justify-center'" class="flex justify-center">Link Existing</button>
																<button @click="openFilePopup('file')" for="upload" :class="TaskDetailsDropDown.taskStatus ==10414 || TaskDetailsDropDown.taskStatus == 10403 || TaskDetailsDropDown.taskStatus == 10417 || presentAuditObject.statusCode == 10403|| presentAuditObject.statusCode == 10418 || presentFindingTaskObj.auditor == userInfo._id || !isAddDisabled(10302)? 'btndisabled pointer-events-none' : 'filterButton flex justify-center'" class="flex justify-center">Attach</button>
															</div>
														</div>
														
														<div v-if="fileEvidences.length" class="flex mt-5 gap-4 flex-wrap">
															<div v-for="(doc, fileIdx) in fileEvidences" :key="'capa-file-'+fileIdx">
																<div class="pdf w-full rounded-sm">
																	<a
																		href="#"
																		@click.prevent="openEvidenceFile(doc)"
																		class="flex w-full flex-row items-center cursor-pointer"
																	>
																			<img src="@/assets/doc.svg" alt="" v-if=" getEvidenceFileExt(doc)=='doc'"/>
																			<img src="@/assets/pdf.svg" alt="" v-if=" getEvidenceFileExt(doc)=='pdf'" />
																			<img src="@/assets/docx.svg" alt="" v-if=" getEvidenceFileExt(doc)=='docx'" />
																			<img src="@/assets/xls.svg" alt="" v-if=" getEvidenceFileExt(doc)=='xls'" />
																			<img src="@/assets/xlsx.svg" alt="" v-if=" getEvidenceFileExt(doc)=='xlsx'" />
																			<img src="@/assets/pdf.svg" alt="" v-if=" getEvidenceFileExt(doc)=='rtf'"/>
																			<img src="@/assets/txt.svg" alt="" v-if=" getEvidenceFileExt(doc)=='txt'"/>
																			<img src="@/assets/png.svg" alt="" v-if=" getEvidenceFileExt(doc)=='png'"/>
																			<img src="@/assets/jpg.svg" alt="" v-if=" getEvidenceFileExt(doc)=='jpg'"/>
																			<img src="@/assets/jpeg.svg" alt="" v-if=" getEvidenceFileExt(doc)=='jpeg'"/>
																			<img src="@/assets/csv.svg" alt="" v-if=" getEvidenceFileExt(doc)=='csv'"/>
																			<img src="@/assets/zip.svg" alt="" v-if=" getEvidenceFileExt(doc)=='zip'"/>
																			<img src="@/assets/mp4.svg" alt="" v-if=" getEvidenceFileExt(doc)=='mp4'"/>
																			<div class="flex flex-col w-full min-w-0">
																				<div class="ml-2 pb-1">
																				<p class="text-xs font-medium truncate" :title="doc.filename || doc.name">{{doc.filename || doc.name || 'N/A'}}</p>
																				</div>
																				<div class="flex justify-between w-full">
																				<p class="ml-2 fontSize10PX">{{doc.evidenceDate?formatFileAttachedTime(doc.evidenceDate):'N/A'}}</p>
																				<p class="mr-2 fontSize10PX font-semibold">{{ evidenceTaskLabel(doc) }}</p>
																				</div>
																			</div>
																			<button v-if="canDeleteAuditEvidence(doc)" type="button" class="evidence-file-delete" @click.stop.prevent="openDeleteEvidenceConfirm(presentFindingTaskObj.files.indexOf(doc))" :class="isEvidenceAttachDisabled() ? 'pointer-events-none' : ''">
																				<img src="@/assets/deleteIcon.svg" alt="Delete" />
																			</button>
																	</a>
																</div>
															</div>
														</div>
														<p v-else class="text-xs text-placeholdergray mt-3">No files attached</p>
														</div>

														<div class="evidence-links-section">
														<div class="border-b border-lightgrey flex justify-between items-center pb-2 mt-6">
															<div class="flex items-center justify-center">
																<p class="header">Links</p>
															</div>
															<div class="buttonposition flex justify-center items-center">
																<button
																	@click="openFilePopup('url')"
																	:class="TaskDetailsDropDown.taskStatus ==10414 || TaskDetailsDropDown.taskStatus == 10403 || TaskDetailsDropDown.taskStatus == 10417 || presentAuditObject.statusCode == 10403|| presentAuditObject.statusCode == 10418 || presentFindingTaskObj.auditor == userInfo._id || !isAddDisabled(10302)? 'btndisabled pointer-events-none' : 'filterButton flex justify-center'"
																	class="flex justify-center"
																>Add Link</button>
															</div>
														</div>
														<div class="evidence-links-wrap" :class="{ 'evidence-links-wrap--empty': filteredLinkCount === 0 }">
															<div class="evidence-links-scroll">
																<div class="evidence-links-header">
																	<table class="evidence-links-table" :style="linkTableResizeStyle">
																		<thead>
																			<tr>
																				<th class="cursor-pointer evidence-links-col-id" @click="sortLinkEvidences('taskId')">
																					<div class="flex items-center">
																						<div>ID</div>
																						<div class="sort cursor-pointer" :class="linkSortKey === 'taskId' ? linkSortClass : 'opacity-50'"></div>
																					</div>
																				</th>
																				<th class="cursor-pointer evidence-links-col-title" @click="sortLinkEvidences('filename')">
																					<div class="flex items-center">
																						<div>Link Title</div>
																						<div class="sort cursor-pointer" :class="linkSortKey === 'filename' ? linkSortClass : 'opacity-50'"></div>
																					</div>
																				</th>
																				<th class="cursor-pointer evidence-links-col-link" @click="sortLinkEvidences('url')">
																					<div class="flex items-center">
																						<div>Link</div>
																						<div class="sort cursor-pointer" :class="linkSortKey === 'url' ? linkSortClass : 'opacity-50'"></div>
																					</div>
																				</th>
																				<th class="cursor-pointer evidence-links-col-date" @click="sortLinkEvidences('evidenceDate')">
																					<div class="flex items-center">
																						<div>Evidence Date</div>
																						<div class="sort cursor-pointer" :class="linkSortKey === 'evidenceDate' ? linkSortClass : 'opacity-50'"></div>
																					</div>
																				</th>
																				<th class="evidence-links-col-action"></th>
																			</tr>
																		</thead>
																	</table>
																</div>
																<div class="evidence-links-body">
																	<table class="evidence-links-table" :style="linkTableResizeStyle">
																		<tbody v-if="paginatedLinkEvidences.length">
																			<tr
																				v-for="(doc, idx) in paginatedLinkEvidences"
																				:key="'link-'+idx"
																				class="rowHeight evidence-links-row"
																			>
																				<td class="evidence-links-col-id" :title="evidenceTaskLabel(doc)">
																					<div class="table-ellipsis">{{ evidenceTaskLabel(doc) }}</div>
																				</td>
																				<td class="evidence-links-col-title" :title="doc.filename || doc.name">
																					<div class="table-ellipsis">{{ doc.filename || doc.name || 'N/A' }}</div>
																				</td>
																				<td class="evidence-links-col-link">
																					<div class="table-ellipsis">
																						<a href="#" class="text-primary evidence-link-anchor cursor-pointer" @click.prevent="openEvidenceFile(doc)" :title="doc.url">{{ doc.url }}</a>
																					</div>
																				</td>
																				<td class="evidence-links-col-date">{{ doc.evidenceDate ? formatFileAttachedTime(doc.evidenceDate) : 'N/A' }}</td>
																				<td class="evidence-links-col-action">
																					<button v-if="canDeleteAuditEvidence(doc)" type="button" class="evidence-links-delete" @click.stop.prevent="openDeleteEvidenceConfirm(presentFindingTaskObj.files.indexOf(doc))" :class="isEvidenceAttachDisabled() ? 'pointer-events-none' : ''">
																						<img src="@/assets/deleteIcon.svg" alt="Delete" class="h-5 w-5" />
																					</button>
																				</td>
																			</tr>
																		</tbody>
																		<tbody v-else>
																			<tr>
																				<td class="evidence-links-empty" colspan="5">
																					<div class="flex justify-center"><p class="text-xs font-normal">No Records Found</p></div>
																				</td>
																			</tr>
																		</tbody>
																	</table>
																</div>
															</div>
															<pagination
																v-if="filteredLinkCount > 0"
																:dynamicPagination="filteredLinkCount"
																:sortedData="sortedLinkEvidences"
																@currentPageUpdate="onLinkPaginationUpdate"
															/>
														</div>
														</div>
														</div>
													</div>
												</div>
												<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 4">
													<div>
														<div class="border-b border-lightgrey flex justify-between pb-2 mt-3">
															<div class="flex items-center justify-center">
																<div>
																	<p class="header">Comments</p>
																</div>
															</div>
															<div>
																<div class="buttonposition flex justify-center items-center">
																	<div class="buttonposition flex justify-center items-center">
																		<button class="filterButton w-24 flex" v-if="oldComments" @click="sortComments()">
																			<img src="@/assets/sortBy.svg" class="h-3 mr-2.5" />
																			Oldest
																		</button>
																		<button class="filterButton w-24 flex" v-if="!oldComments" @click="sortComments()">
																			<img src="@/assets/sortBy.svg" class="h-3 mr-2.5 rotate-180" />
																			Newest
																		</button>
																	</div>
																</div>
															</div>
														</div>
														<div>
															<div class="comment-box w-full mt-5">
																<!-- <div class="my-3 headerText"><textarea placeholder="Add a Comment" class="w-full border border-lightgrey rounded-sm p-2" rows="4" :disabled="TaskDetailsDropDown.taskStatus == 10403 || TaskDetailsDropDown.taskStatus == 10417 || presentAuditObject.statusCode == 10403|| presentAuditObject.statusCode == 10418" v-model="comment" @input="handleInput"></textarea></div>
																<div class="flex justify-end">
																	<button @click="addComment" class="mr-2" :class="{ btnprimary: !btnDisabled, btndisabled: btnDisabled }" :disabled="btnDisabled">Add</button>
																	<button @click="clearComment" :class="{ btnprimary: !btnDisabled, btndisabled: btnDisabled }" :disabled="btnDisabled">Cancel</button>
																</div> -->
																<commentsEditor v-if="TaskDetailsDropDown.taskStatus!=10403 && TaskDetailsDropDown.taskStatus!=10418 &&isAddDisabled(10302)" :taskStatusCode="TaskDetailsDropDown.taskStatus"/>
															</div>
															<div v-if="Object.keys(presentFindingTaskObj).includes('comments')" class="comments">
																<div v-for="(obj, index) in presentFindingTaskObj.comments" class="border border-lightgrey mt-2 rounded-sm flex flex-row p-3" :key="index">
																	<div class="initials">{{extractInitials((obj.name) )}}</div>
																	<div class="w-20">
																		<div class="header">{{ obj.name }}</div>
																		<div class="fontSize10PX">{{ obj.createdAt }}</div>
																	</div>
																	<div class="w-80 headerText">
																	<safeHtml :content="obj.comment"/>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 5">
													<div>
														<div class="border-b border-lightgrey flex justify-between pb-2 mt-3">
															<div class="flex items-center justify-center">
																<div>
																	<p class="header">Approvals</p>
																</div>
															</div>
															<div>
																<div class="buttonposition flex justify-center items-center">
																	<button @click="openApprovalpopup()" :class="TaskDetailsDropDown.taskStatus ==10419 || approvalObj.statusCode == 10401 || presentFindingTaskObj.statusCode == 10403 ||  presentFindingTaskObj.auditor == userInfo._id||  (newTeamAssignee.value != userInfo._id  && presentFindingTaskObj.auditee != userInfo._id || userInfo?.role_id!=10217 && userInfo.roleId!=10217) || !isAddDisabled(10302)?'btndisabled pointer-events-none' : 'filterButton flex justify-center'" class="flex justify-center ">Send Approval</button>
																</div>
															</div>
														</div>
														<div>
															<div v-for="(approval, number) in presentFindingTaskObj.approvals" :key="number" class="bg-white flex flex-row p-4 mb-0.5 border-lightgrey border-b w-full">
																<div v-if="approval.createdBy != undefined" class="initials">{{extractInitials(approval.name)}}</div>
																<div v-if="approval.createdBy != undefined" class="font-semibold mt-1 text-xs">{{ approval.name }}</div>
																<div v-if="approval.updatedBy != undefined" class="initials">{{extractInitials(approval.name)}}</div>
																<div v-if="approval.updatedBy != undefined" class="font-semibold mt-1 text-xs">{{ approval.name }}</div>
																<div v-if="approval.statusCode == 10401" class="mx-2 mt-1 text-xs"> {{' Requested an approval '}} </div>
																<div v-if="approval.statusCode == 10410" class="mx-2 mt-1 text-xs"> {{' Rejected an approval '}} </div>
																<div v-else-if="approval.statusCode == 10403" class="mx-2 mt-1 text-xs"> {{' Approved an approval '}} </div>
																<div  v-if="approval.createdAt != undefined" class="font-semibold mt-1 text-xs">{{approval.createdAt}}</div>
																<div  v-if="approval.updatedAt != undefined" class="font-semibold mt-1 text-xs">{{approval.updatedAt}}</div>
															</div>
														</div>
													</div>
												</div>
												<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 6">
													<div>
														<div class="border-b border-lightgrey flex justify-between pb-2 mt-3">
															<div class="flex items-center justify-center">
																<div>
																	<p class="header">History</p>
																</div>
															</div>
															<div>
																<div class="buttonposition flex justify-center items-center">
																	<div class="buttonposition flex justify-center items-center">
																		<button class="filterButton w-24 flex " v-if="newHistory" @click="sortWorkLog()">
																			<img src="@/assets/sortBy.svg" class="h-3 mr-2.5" />
																			Oldest
																		</button>
																		<button class="filterButton w-24 flex " v-if="!newHistory" @click="sortWorkLog()">
																			<img src="@/assets/sortBy.svg" class="h-3 mr-2.5 rotate-180" />
																			Newest
																		</button>
																	</div>
																</div>
															</div>
														</div>
															<div>
																
																<div v-for="work in workLogObject.taskHistory" :key="work" class="bg-white p-4 px-0 mb-0.5 border-lightgrey border-b w-full">
																	<div class="flex">
																		<div v-if="checkKey(work,'createdBy')" class="initials">
																			{{ extractInitials(work.name) }}
																		</div>
																		<div v-if="Object.keys(work).includes('updatedBy')" class="initials">
																			{{ extractInitials(work.name) }}
																		</div>
																		<div class="logContainer w-93">
																			<div class="flex mt-1">
																				<p v-if="Object.keys(work).includes('createdBy')" class="font-semibold mt-1 text-xs">
																					{{ work.name }}
																				</p>
																				<p v-else-if="Object.keys(work).includes('updatedBy')" class="font-semibold mt-1 text-xs">
																					{{ work.name }}
																				</p>

																				<p v-if="work.actionEntity == 10301" class="mx-2 mt-1 text-xs">{{ 'Created the Task on' }}</p>
																				<p v-else-if="work.statusCode != undefined && work.statusCode == 10418" class="mx-2 mt-1 text-xs">{{ 'Terminated the Task on' }}</p>
																				<p v-else-if="work.actionEntity == 10302&& !Object.keys(work.additionalInfo).includes('previousDueDate')" class="mx-2 mt-1 text-xs">{{ 'Updated the Task on' }}</p>
																				<p v-else-if="work.actionEntity == 10302 && Object.keys(work.additionalInfo).includes('previousDueDate')" class="mx-2 mt-1 text-xs">{{ 'Updated the Due Date at' }}</p>

																				<p v-if="Object.keys(work).includes('createdAt')" class="font-semibold mt-1 text-xs">{{ formatTime(work.createdAt) }}</p>
																				<p v-if="Object.keys(work).includes('updatedAt')" class="font-semibold mt-1 text-xs">{{ formatTime(work.updatedAt) }}</p>
																			</div>
																			
																			<div class="mt-3" v-if="Object.keys(work).includes('additionalInfo')">
																				
																					<div v-if="work.additionalInfo">
																						<div v-if="checkKey(work.additionalInfo,'comment')" class="flex">
																							<div class="font-semibold text-xs widthForCommentBox">Comment :</div>
																							<div class="text-xs w-full ">
																								<safeHtml :content="work.additionalInfo.comment"/>
																							</div>
																						</div>
																					<div class="flex" v-if="Object.keys(work.additionalInfo).includes('evidence') && !work.additionalInfo.removed">
																						<p class="font-semibold text-xs">{{'Uploaded the Evidence -'}}</p>
																						<p class="mx-2 text-xs">{{ work.additionalInfo.evidence }}</p>
																					</div>
																					<div class="flex" v-if="work.additionalInfo.removed">
																						<p class="font-semibold text-xs">{{'Deleted the Evidence -'}}</p>
																						<p class="mx-2 text-xs">{{ work.additionalInfo.evidence }}</p>
																					</div>
																					<div class="flex" v-if="Object.keys(work.additionalInfo).includes('linkedEvidenceTitles')">
																						<p class="font-semibold text-xs">{{'Linked the Evidence -'}}</p>
																						<p class="mx-2 text-xs">{{ work.additionalInfo.linkedEvidenceTitles }}</p>
																					</div>
																					<div class="flex mt-2" v-if="Object.keys(work.additionalInfo).includes('linkedEvidenceDates')">
																						<p class="font-semibold text-xs">{{'Linked Evidence Date -'}}</p>
																						<p class="mx-2 text-xs">{{ work.additionalInfo.linkedEvidenceDates }}</p>
																					</div>
																					<div class="flex mt-2" v-if="Object.keys(work.additionalInfo).includes('evidenceDate')">
																						<p class="font-semibold text-xs">{{'Evidence Date -'}}</p>
																						<p class="mx-2 text-xs">{{ formatDate(work.additionalInfo.evidenceDate)||'N/A' }}</p>
																					</div>
																					<div class="flex mt-2" v-if="Object.keys(work.additionalInfo).includes('previousDueDate')">
																						<p class="font-semibold text-xs">{{'from '}}</p>
																						<p class="mx-2 text-xs">{{ formatDate(work.additionalInfo.previousDueDate)||'N/A' }}</p>
																						<p class="font-semibold text-xs">{{'to'}}</p>
																						<p class="mx-2 text-xs">{{ formatDate(work.additionalInfo.updatedDueDate)||'N/A' }}</p>
																					</div>
																					<div class="flex" v-if="Object.keys(work.additionalInfo).includes('assignee')">
																						<p class="font-semibold text-xs">{{'Assigned the Task To -'}}</p>
																						<p class="mx-2 text-xs">{{ getPersonName(work.additionalInfo.assignee) }}</p>
																					</div>
																					<div class="flex" v-if="Object.keys(work.additionalInfo).includes('approver')">
																						<div v-if="work.additionalInfo.action == 10301">
																							<p class="font-semibold text-xs">{{'Sent Approval for -'}}</p>
																						</div>
																						<div v-if="work.additionalInfo.action == 10302 && work.additionalInfo.statusCode == 10403">
																							<p class="font-semibold text-xs">{{'Approved Approval -'}}</p>
																						</div>
																						<div class="flex" v-if="work.additionalInfo.action == 10302 && work.additionalInfo.statusCode == 10410">
																							<p class="font-semibold text-xs">{{'Rejected Approval -'}}</p>
																						</div>
																						<p class="mx-2 text-xs text-justify">{{ getPersonName(work.additionalInfo.approver) }}</p>
																				</div> 
																					<div class="flex items-center" v-if="Object.keys(work.additionalInfo).includes('previousStatus')">
																					<div>
																						<p class="font-semibold text-xs">{{'Updated the status :'}}</p>
																					</div>
																					<!-- <div v-if="checkKey(work.additionalInfo,'action')" class="flex">
																						<div class="font-semibold text-xs w-12">Approval :</div>
																						<div class="text-xs w-88 ">{{ work.additionalInfo.checkapproval }}</div>
																						<div v-for="(approval, number) in presentFindingTaskObj.approvals" :key="number" class="bg-white flex flex-row p-4 mb-0.5 border-lightgrey border-b w-full">
																							<div class="initials">{{extractInitials(getPersonName(work.additionalInfo.createdBy))}}</div>
																							<div class="font-semibold mt-1 text-xs">{{ getPersonName(work.additionalInfo.createdBy) }}</div>
																							<div v-if="work.additionalInfo.statusCode == 10401" class="mx-2 mt-1 text-xs"> {{' Requested an approval '}} </div>
																							<div v-else-if="work.additionalInfo.statusCode == 10410" class="mx-2 mt-1 text-xs"> {{' Rejected an approval '}} </div>
																							<div v-else-if="work.additionalInfo.statusCode == 10403" class="mx-2 mt-1 text-xs"> {{' Approved an approval '}} </div>
																							<div class="font-semibold mt-1 text-xs">{{work.additionalInfo.createdAt}}</div>
																						</div>
																					</div> -->
																					<div class="flex ml-4">
																						<div class="flex items-center justify-center rounded h-5 labelWidth" :class="colorFindingBg(work.additionalInfo.previousStatus)">
																							<div :class="colorFindingText(work.additionalInfo.previousStatus)">
																								{{ getStatusLabel(work.additionalInfo.previousStatus) }}
																							</div>
																						</div>
																						<div class="mx-4 flex items-center"><img src="@/assets/arrowRight.svg"/></div>
																							<div class="flex items-center justify-center rounded h-5 labelWidth" :class="colorFindingBg(work.additionalInfo.updatedStatus)">
																								<div :class="colorFindingText(work.additionalInfo.updatedStatus)">
																									{{ getStatusLabel(work.additionalInfo.updatedStatus) }}
																								</div>
																							</div>
																						</div>
																					</div>
																					</div>

																				
																				<!-- <div v-if="Object.keys(work.additionalInfo).includes('evidence')" class="flex">
																					<div class="font-semibold text-xs w-12">Comment :</div>
																					<div class="text-xs w-88 ">{{ work.addtionalInfo.comment }}</div>
																				</div>
																				<div class="flex" v-if="Object.keys(work.additionalInfo).includes('evidence')">
																					<p class="font-semibold text-xs">{{'Uploaded the Evidence -'}}</p>
																					<p class="mx-2 text-xs">{{ work.additionalInfo.evidence }}</p>
																				</div>
																				
																				<div class="flex" v-if="Object.keys(work.addtionalInfo).includes('assignee')">
																					<p class="font-semibold text-xs">{{'Assigned the Task To -'}}</p>
																					<p class="mx-2 text-xs">{{ getPersonName(work.addtionalInfo.assignee) }}</p>
																				</div> -->
																				
																			</div>
																		</div>
																	</div>
																</div>
															</div>

														<!-- </div> -->
													</div>
												</div>
											</div>
										</TabPanel>
									</TabPanels>
								</Tabs>			
							</div>
							<div class="w-20 border taskDetailsRightBar rounded-sm border-lightgrey">
								<div class="m-3">
									<div class="pb-2 border-b border-lightgrey">
										<h1>Task Details</h1>
									</div>
									<div v-if="tabDataLoading == true">
										<div class="flex items-center justify-center w-full h-16 skeleton">
										<dots-loader/>
										</div>
									</div>
									<div v-else class="pt-1.5 overflow-y-scroll thirtyWidthToggle">
										<div class="flex flex-col">
											<label class="controllabel">Task Status</label> 
											<div>
												<div v-if="TaskDetailsDropDown.taskStatus == 10418" class="bg-error textColorWhite inputboxstyling1 cursor-pointer mt-2 ">
													<div class="bg-error textColorWhite">{{'Terminated'}}</div>
												</div>
												<input disabled v-else-if="TaskDetailsDropDown.taskStatus == 10403" type="text" placeholder="Status" class="completedBox inputboxstyling mt-2 " value="Completed" />

												<!-- <select
													class="mt-2  custom-select cursor-pointer w-full px-2.5 py-1 text-sm font-light text-gray rounded-sm border-solid border border-lightgrey"
													:class="changeBackground()"
													v-if="(checkAuditor(presentFindingTaskObj.auditor)) && (TaskDetailsDropDown.taskStatus == 10419 || TaskDetailsDropDown.taskStatus == 10415)"		
													v-model="TaskDetailsDropDown.taskStatus"
													@change="updateTaskStatus(TaskDetailsDropDown.taskStatus)"
												>
													<option value="" selected disabled hidden>Please select one</option>
													<option v-for="i in auditorTaskData" :disabled="i.id==10403" :class="i.id == 10403 ? 'taskStatusOptionsForNotStarted' : 'taskStatusOptions'" :value="i.id" :key="i">
														{{ i.value }}
													</option>
												</select> -->
												<Select
													appendTo="body"
													v-model="TaskDetailsDropDown.taskStatus"
													v-if="(checkAuditor(presentFindingTaskObj.auditor)) && (TaskDetailsDropDown.taskStatus == 10414 || TaskDetailsDropDown.taskStatus == 10421)"
													:options="auditorTaskData"
													optionLabel="value"
													optionValue="id"
													placeholder="Please select one"
													class="custom-select w-full mt-2 mb-3 px-2.5 py-1 text-sm font-light text-gray rounded-sm border border-lightgrey selectIcon"
													:class="changeBackground()"
													@change="updateTaskStatus(TaskDetailsDropDown.taskStatus)"
													:optionDisabled="isOptionDisabled"
												/>
												<!-- <select
													class=" mt-2  custom-select cursor-pointer w-full px-2.5 py-1 text-sm font-light text-gray rounded-sm border-solid border border-lightgrey"
													:class="changeBackground()"
													v-else-if="!(checkAuditor(presentFindingTaskObj.auditor)) && (TaskDetailsDropDown.taskStatus == 10401 || TaskDetailsDropDown.taskStatus == 10402 || TaskDetailsDropDown.taskStatus == 10408 || TaskDetailsDropDown.taskStatus == 10419)"
													:disabled="TaskDetailsDropDown.taskStatus == 10419 ||  TaskDetailsDropDown.taskStatus == 10415 ||  TaskDetailsDropDown.taskStatus == 10403"
													v-model="TaskDetailsDropDown.taskStatus"
													@change="updateTaskStatus(TaskDetailsDropDown.taskStatus)"
												>
													<option value="" selected disabled hidden>Please select one</option>
													<option v-for="i in taskStatusData" :value="i.id" :key="i">
														{{ i.value }}
													</option>
												</select> -->
												<Select
													appendTo="body"
													v-model="TaskDetailsDropDown.taskStatus"
													:options="taskStatusData"
													optionLabel="value"
													optionValue="id"
													placeholder="Please select one"
													class="custom-select w-full mt-2 mb-3 px-2.5 py-1 text-sm font-light text-gray rounded-sm border border-lightgrey"
													:class="changeBackground()"
													v-else-if="!(checkAuditor(presentFindingTaskObj.auditor)) && (TaskDetailsDropDown.taskStatus == 10401 || TaskDetailsDropDown.taskStatus == 10402 || TaskDetailsDropDown.taskStatus == 10408 || TaskDetailsDropDown.taskStatus == 10414)"
													:disabled="TaskDetailsDropDown.taskStatus == 10414 ||  TaskDetailsDropDown.taskStatus == 10421 ||  TaskDetailsDropDown.taskStatus == 10403 "
													@change="updateTaskStatus(TaskDetailsDropDown.taskStatus)"
													:optionDisabled="isOptionDisabled"
												/>
											</div>
											<div>
												<div v-if="!(checkAuditor(presentFindingTaskObj.auditor)) && (presentFindingTaskObj.statusCode == 10421 )" :class="changeBackground()" class="inputboxstyling1 disabled cursor-pointer mt-2 " >
													<div :class="changeBackground()" @change="updateTaskStatus(TaskDetailsDropDown.taskStatus)">
														{{ 
															auditorTaskData.find((data)=>{
																return data.id == presentFindingTaskObj.statusCode
															}).value
														}}
													</div>
												</div>
												<div v-if="(checkAuditor(presentFindingTaskObj.auditor)) && (TaskDetailsDropDown.taskStatus == 10401 || TaskDetailsDropDown.taskStatus == 10402 || TaskDetailsDropDown.taskStatus == 10408)" :class="changeBackground()" class="inputboxstyling1 disabled cursor-pointer mt-2" :disabled="!isAddDisabled(10302)">
													<div :class="changeBackground()" @change="updateTaskStatus(TaskDetailsDropDown.taskStatus)">
														{{ 
															taskStatusData.find((data)=>{
																return data.id == presentFindingTaskObj.statusCode
															}).value
														}}
													</div>
												</div>
											</div>
										</div>
			
										<div>
											<div class="mt-2">
												<label class="controllabel">Assigned To</label>	
												<div class="mt-2" v-if="TaskDetailsDropDown.taskStatus ==10414 || TaskDetailsDropDown.taskStatus == 10403 || TaskDetailsDropDown.taskStatus == 10417 || presentFindingTaskObj.statusCode == 10403|| presentFindingTaskObj.statusCode == 10418 || (newTeamAssignee.value != userInfo._id  && presentFindingTaskObj.auditee == userInfo._id)">{{presentFindingTaskObj.assignee != undefined ? presentFindingTaskObj.assignee.label : 'N/A'}}</div>
												<div v-else>
													<!-- <multiselect
														v-model="presentFindingTaskObj.assignee"
														:options="userOptions"
														:showNoOptions="false"
														@search-change="asyncFind"
														:limit-text="limitText"
														:multiple="false"
														:close-on-select="true"
														:clear-on-select="true"
														label="label"
														open-direction="bottom"
														:hide-selected="true"
														track-by="value"   
														@select="updateAssignedMember(presentFindingTaskObj.assignee)" 
														:searchable="true"
														:hideArrow="false"
														placeholder="Assigned-To"
														deselectLabel=""
														selectLabel=""
														class="custom-multiselect userSelect mt-2"
														:class="{
															'has-options': userOptions && userOptions.length > 0,
															'no-options': !userOptions.length &&  searchValue !== '',
														}"
													>
														<template v-slot:noResult>
															<span class="text-xs">No Members Found</span>
														</template>
													</multiselect> -->
													<AutoComplete
														appendTo="body"
														v-model="presentFindingTaskObj.assignee"
														:suggestions="userOptions"
														placeholder="Assigned-To"
														optionLabel="label"
														field="label"
														class="w-full custom-autocomplete userSelect mt-2"
														@complete="asyncFind"
														:disabled="!isAddDisabled(10302)"
														@item-select="updateAssignedMember(presentFindingTaskObj.assignee)"
														/>
												</div>
											</div>
										</div>
										<!-- <div class="mt-3">
											<label class="controllabel">Due Date</label><br>
											<div class="mt-2 text-sm rounded w-24" v-if="presentFindingTaskObj.dueDate != undefined" :class="colorForDueDate(presentFindingTaskObj.dueDate)">{{ formatDate(presentFindingTaskObj.dueDate) }}</div>
											<p class="mt-2 text-sm" v-else>N/A</p>
										</div> -->
										<div class="mt-3">
											<label class="controllabel">Due Date</label><br>
											<div>
												<input
													type="date"
													v-model="presentFindingTaskObj.dueDate"
													class="mt-2 w-full stylingForInputboxstylingForSelectAtPopup"
													@focus="openCalendar"
													onkeydown="return false"
													placeholder="Select Date"
													:disabled="TaskDetailsDropDown.taskStatus ==10403||TaskDetailsDropDown.taskStatus ==10418"
													@change="updateTaskDueDate(7,presentFindingTaskObj.dueDate)"
												/>
											</div>
										</div>

										<div class="mt-3">
											<label class="controllabel">Auditor</label><br>
											<div class="my-1 mt-2 text-sm" v-if="presentFindingTaskObj.auditor != undefined || presentFindingTaskObj.auditor != null">{{ getPerson(presentFindingTaskObj.auditor) }}</div>
											<p class="mt-2 text-sm" v-else>N/A</p>
										</div>
										<div class="mt-3">
											<label class="controllabel">Auditee</label><br>
											<div class="my-1 text-sm" v-if="presentFindingTaskObj.auditee != undefined || presentFindingTaskObj.auditee != null">{{ getPersonName(presentFindingTaskObj.auditee) }}</div>
											<p class="mt-2 text-sm" v-else>N/A</p>
										</div>
										<div class="mt-3">
											<label class="controllabel">Team</label><br>
											<div class="my-1 text-sm" v-if="presentFindingTaskObj.department != undefined || presentFindingTaskObj.department != null">{{ getTeamName(presentFindingTaskObj.department) }}</div>
											<p class="mt-2 text-sm" v-else>N/A</p>
										</div>
										<div class="mt-3">
											<label class="controllabel">Location</label><br>
											<div class="my-1 text-sm" v-if="presentFindingTaskObj.department"> {{ getLocationName(presentFindingTaskObj.department) }}</div>
											<!-- <div class="mt-2 text-sm" v-else>{{ 'N/A' }}</div> -->
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<popup v-if="importpopUp" :popUp="importpopUp">
				<div class="overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-end items-start flex">
				<div class="relative w-full max-w-xl">
				<!--content-->
				<div class="border-0 rounded relative flex flex-col w-full bg-white h-screen">
					<!--header-->
					<div class="flex items-center justify-between popupheadingcontainer rounded">
					<h1>{{ evidenceAttachMode === 'url' ? 'Attach Link' : 'Attach File' }}</h1>
					<button class="p-1 ml-auto float-right text-3xl leading-none font-semibold outline-none focus:outline-none" @click="onCancelIcon()">
						<img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
					</button>
					</div>
					<div class="border-b border-solid border-lightgrey ml-4 mr-4"></div>
					<div class="flex-1 overflow-auto">
						<div class="impactcontainer popupbodycontainer">
						<div class="formcontainer flex flex-col">
							<div class="row flex flex-col mt-2">
							<div>
								<label class="controllabel">{{ evidenceAttachMode === 'url' ? 'Title' : 'File Name' }} </label>
								<input class="inputboxstyling text-xs mt-2" type="text" v-model.trim="inputFileName" :placeholder="evidenceAttachMode === 'url' ? 'Evidence title' : 'Filename'"  :class="{'is-invalid': v$.inputFileName.$error }" @input="v$.inputFileName.$touch()"/>
								<div v-if="v$.inputFileName.$error " class="text-red-500">
									<div class="error-text text-xs" v-if="v$.inputFileName.required.$invalid ">Required</div>
									<div v-else-if="(v$.inputFileName.restrictCharacters50 && v$.inputFileName.restrictCharacters50.$invalid) || (v$.inputFileName.restrictCharacters60 && v$.inputFileName.restrictCharacters60.$invalid)" class="error-text text-xs">Charcter Limit is exceeded</div>
								</div>
							</div>
							<div class="pt-3" v-if="evidenceAttachMode === 'file'">
							<label class="controllabel">Attachment</label>
							<input
							type="file"
							ref="fileInput"
							class="hidden"
							id="upload"
							@change="handleFileUpload"
							/>
							<div 
							class="w-auto rounded-sm mt-2 p-8
									flex flex-col items-center justify-center text-center transition
									border-2 border-dashed border-lightgrey bg-whitegrey"
							:class="{
								'is-invalid': v$.fileToUpload.$error || pdfValidation,
								'border-primary': isDragOver
							}"
							@dragenter.prevent="onDragOver"
							@dragover.prevent="onDragOver"
							@dragleave.prevent="onDragLeave"
							@drop.prevent="onFileDrop"
							>
							<img
								src="@/assets/fileUploadIcon.svg"
								class="h-10 w-10 mb-3"
								alt="Upload file"
							/>

							<p v-if="fileName === ''" class="text-sm font-semibold text-darkblue mb-4">
								Drag and drop your file here
							</p>
							<p v-else class="text-sm font-semibold text-primary mb-4">
								{{ fileName }}
							</p>
							<div class="flex items-center justify-center gap-2">
								<label for="upload" class="cursor-pointer">
								<span class="btnprimary text-xs gap-1">
									<img src="@/assets/Browse.svg" class="h-4 w-4" alt="" />
									Browse
								</span>
								</label>

								<button
								type="button"
								class="filterButton text-xs gap-1"
								:class="fileName === '' ? 'filterButtondisabled pointer-events-none' : ''"
								:disabled="fileName === ''"
								@click="clearSelectedFile"
								>
								Cancel
								</button>
							</div>
							</div>
							<div class="min-h-[22px] text-red-500">
							<div
								v-if="v$.fileToUpload.$invalid && !pdfValidation && (v$.fileToUpload.$error || pdfValidation)"
								class="error-text text-xs"
							>
								File upload is required
							</div>
							<div
								v-if="pdfValidation && !v$.fileToUpload.$invalid"
								class="text-red-500 text-xs"
							>
								This File Format is not Supported
							</div>
							</div>
							<div class="mt-2 flex flex-col items-center">
							<p class="text-xs text-placeholder">
							Accepted Formats: PDF, JPG, PNG, ZIP, TXT, XLS, DOC, MP4
							</p>
							<p class="text-xs text-placeholder mt-1">
							Maximum File Size: 50 MB
							</p>
							</div>
						</div>
							<div class="pt-3" v-if="evidenceAttachMode === 'url'">
								<label class="controllabel">URL</label>
								<input
									class="inputboxstyling text-xs mt-2"
									type="url"
									v-model.trim="evidenceUrl"
									placeholder="URL"
									@input="v$.evidenceUrl.$touch()"
									:class="{'is-invalid': v$.evidenceUrl.$error }"
								/>
								<div v-if="v$.evidenceUrl.$error" class="text-red-500">
									<div class="error-text text-xs" v-if="v$.evidenceUrl.required.$invalid">Required</div>
									<div class="error-text text-xs" v-else-if="v$.evidenceUrl.httpUrl.$invalid">URL must use http or https</div>
								</div>
							</div>
							<div class="pt-3 w-1/2">
								<label class="controllabel">Evidence Date</label>
								<input
								v-model="evidenceDate"
								type="date"
								class="mt-2 w-full"
								@focus="openCalendar"
								style="height:28px"
								onkeydown="return false"
								:class="{
									'inputboxstylingForSelectAtPopup': evidenceDate == '',
									'stylingForInputboxstylingForSelectAtPopup': evidenceDate != '',
									'is-invalid':v$.evidenceDate.$error
									}"
								
								placeholder="Select Date"
								:max="todayDate"

								/>
								<div v-if="v$.evidenceDate.$error" class="text-red-500">
								<div v-if="v$.evidenceDate.$invalid" class="error-text text-xs">Evidence date is required</div>
								</div>
							</div>
							</div>
						</div>
						</div>

					</div>
					<!--footer-->
					<div>
						<div class="border-b border-solid border-lightgrey mx-5"></div>
					<div class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5">
						<button class="btnprimary" @click="handleFileChange" :class="isEvidenceSaveDisabled ? 'btndisabled pointer-events-none ' : 'btnprimary'"  :disabled="clickOnButton">Save</button>
					</div>
					</div>
				</div>
				</div>
				</div>
			</popup>
			<popup v-if="showApprovalPopup" :popUp="showApprovalPopup">
				<div class="overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-end items-start flex">
				<div class="relative w-full max-w-xl">
				<div class="border-0 rounded relative flex flex-col w-full bg-white h-screen">	
					<div class="flex items-center justify-between popupheadingcontainer rounded">
						<h1>Approval</h1>

						<button class="float-right text-3xl" @click="onCrossbtn()">
							<img src="@/assets/cancel.svg" class="cursor-pointer" />
						</button>
					</div>
				<div class="border-b border-solid border-lightgrey ml-4 mr-4"></div>
				<div  class='flex flex-col h-full'>
					<div class="flex-1 overflow-auto">
						<div class="statuscontainer px-5 pb-5 h-full">
							<div class="formcontainer flex flex-col">
								<div class="row flex flex-row mt-3">
									<div class=" w-1/2">
										<label class="controllabel">Name of the Authority</label>
										<!-- <multiselect
											v-model="approvalSent"
											:options="userOptions"
											:showNoOptions="false"
											@search-change="asyncFind"
											:limit-text="limitText"
											:multiple="false"
											label="label"
											open-direction="bottom"
											track-by="value"
											:searchable="true"
											:hideArrow="false"
											placeholder="Assigned-To"
											deselectLabel=""
											selectLabel=""
											class="custom-multiselect mt-2"
											:class="{
												'has-options': userOptions && userOptions.length > 0,
												'no-options': !userOptions.length &&  searchValue !== '',
											}"
										>
										<template v-slot:noResult>
											<span class="text-xs">No Members Found</span>
										</template>
										</multiselect> -->
										<AutoComplete
											appendTo="body"
											v-model="approvalSent"
											:suggestions="userOptions"
											placeholder="Assigned-To"
											optionLabel="label"
											field="label"
											class="w-full custom-autocomplete userSelect mt-2"
											@complete="asyncFindApprovals"
											:class="{
												'has-options': userOptions && userOptions.length > 0,
												'no-options': !userOptions.length &&  searchValue !== '',
											}"
										/>

										<!-- <select disabled class="inputboxstyling" :value="presentFindingTaskObj.auditee">
											<option v-for="option in orgUsersList" :value="option._id">{{option.name}}</option>
										</select> -->
										<!-- <div class="inputboxstyling" disabled>{{ getPersonName(presentFindingTaskObj.auditee) }}</div> -->
											<!-- <input type="text" :value="getPerson(presentFindingTaskObj.auditee)" class="inputboxstyling"/> -->
									</div >
								</div>
							</div>
							<div class="row flex flex-row mt-3">
								<div class="w-full">
									<label class="controllabel">Justification or Comments for Approving</label>
									<textarea
										class="inputboxstyling mt-2"
										placeholder="Comments"
										v-model.trim="taskObj.approvalComments"
									/>
								</div>
							</div>
						</div>
					</div>
					<div>
						<div class="border-b border-solid border-lightgrey mx-5"></div>
						<div class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5">
							<button class="btnprimary mr-2" :class="(taskObj.approvalComments=='')?'btndisabled pointer-events-none':'btnprimary'" @click="onCancelbtnAtApproval()">Cancel</button>
							<button class="btnprimary" :class="(taskObj.approvalComments=='')?'btndisabled pointer-events-none':'btnprimary'" :disabled="clickOnButtonForApproval" @click="clickOnSaveForApproval()">Save</button>
						</div>
					</div>
				</div>
				</div>
				</div>
				</div>
			</popup>

			<popup v-if="showRejectPopupForNormalApproval" :popUp="showRejectPopupForNormalApproval">
					<template v-slot:header>
						<div
						class="flex items-center justify-between popupheadingcontainer rounded"
						>
						<h1>Justification to Reject an Approval</h1>

						<button class="float-right text-3xl" @click="onCrossBtnForNormalApproval()">
							<img src="@/assets/cancel.svg" class="cursor-pointer" />
						</button>
						</div>
					</template>

				<div class="flex flex-col h-full">
					<div class="flex-1 overflow-auto">
					<div>
						<div class="statuscontainer px-5 py-5">
						<div class="formcontainer flex flex-col w-full">
								<label class="controllabel"
								>Justification or Comments for Rejecting</label
								>
								<textarea
								class="inputboxstyling mt-2"
								placeholder="Comments"
								v-model.trim="normalJustification.justification"
								/>
						</div>
						</div>
					</div>
					</div>
					<div>
					<div class="border-b border-solid border-lightgrey mx-5"></div>
					<div
						class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5"
					>
						<button
						class="btnprimary mr-2"
						:class="
							normalJustification.justification == ''
							? 'btndisabled pointer-events-none'
							: 'btnprimary'
						"
						@click="onCancelbtnForNormalApproval()"
						>
						Cancel
						</button>
						<button
						class="btnprimary"
						:class="
							normalJustification.justification == ''
							? 'btndisabled pointer-events-none'
							: 'btnprimary'
						"
						@click="approveOrRejectForActionTasktoComplete(10401,7)"
						:disabled="clickOnButtonForApproveOrReject"
						>
						Save
						</button>
					</div>

					</div>
				</div>
			</popup>
			

			<popup v-if="showRejectPopupAtInReview" :popUp="showRejectPopupAtInReview">
			<template v-slot:header>
				<div
				class="flex items-center justify-between popupheadingcontainer rounded"
				>
				<h1>Justification to Reject an Approval</h1>

				<button class="float-right text-3xl" @click="onCrossBtnForFinalApproval()">
					<img src="@/assets/cancel.svg" class="cursor-pointer" />
				</button>
				</div>
			</template>

			<div class="popup-business">
				<div>
				<div>
					<div class="statuscontainer px-4 py-4">
					<div class="formcontainer flex flex-col w-full">
							<label class="controllabel"
							>Justification or Comments for Rejecting</label
							>
							<textarea
							class="inputboxstyling mt-2"
							placeholder="Comments"
							v-model.trim="finalJustification.justification"
							/>
					</div>
					</div>
				</div>
				<div
					class="buttonposition flex justify-center items-center mb-4 mx-0"
				>
					<button
					class="btnprimary mr-2"
					:class="
						finalJustification.justification == ''
						? 'btndisabled pointer-events-none'
						: 'btnprimary'
					"
					@click="onCancelbtnForFinalApproval()"
					>
					Cancel
					</button>
					<button
					class="btnprimary"
					:class="
						finalJustification.justification == ''
						? 'btndisabled pointer-events-none'
						: 'btnprimary'
					"
					@click="ApprovalforInprogress(10410)"
					:disabled="clickOnButtonForInProgress"
					>
					Save
					</button>
				</div>
				</div>
			</div>
			</popup>
		</div>
		<div v-if="showDeleteEvidenceConfirm" class="evidence-delete-confirm">
			<div class="evidence-delete-backdrop" @click="cancelDeleteEvidence"></div>
			<div class="evidence-delete-dialog">
				<div class="evidence-delete-dialog-title">
					<div class="evidence-delete-warning">
						<img src="@/assets/warning.svg" class="evidence-delete-warning-icon" alt="" />
					</div>
					<span>Delete Evidence</span>
				</div>
				<p class="evidence-delete-dialog-message">Are you sure you want to delete this evidence?</p>
				<div class="evidence-delete-dialog-actions">
					<button type="button" class="evidence-delete-cancel" @click="cancelDeleteEvidence">Cancel</button>
					<button type="button" class="evidence-delete-ok" @click="confirmDeleteEvidence">OK</button>
				</div>
			</div>
		</div>
		<div v-if="linkEvidencePopup" class="link-existing-confirm">
			<div class="link-existing-backdrop" @click="closeLinkEvidencePopup"></div>
			<div class="link-existing-dialog">
				<div class="link-existing-title">
					<span class="link-existing-warning" aria-hidden="true">
						<img src="@/assets/warning.svg" class="link-existing-warning-icon" alt="" />
					</span>
					<span>Link Existing Evidence</span>
				</div>
				<p class="link-existing-message">Select evidence from the past year listed below.</p>
				<div class="link-existing-tables">
					<div class="link-existing-section-row">
						<div class="link-existing-section">EXISTING EVIDENCE ({{ filteredSortedExistingEvidences.length }})</div>
						<button type="button" class="filterButton flex" @click="toggleExistingEvidenceFilters">
							<img src="@/assets/filter.svg" class="filterIcon" />
							Filters
						</button>
					</div>
					<div class="link-existing-table-wrap" :class="{ 'link-existing-table-wrap--empty': filteredSortedExistingEvidences.length === 0 }">
						<table class="link-existing-table">
							<thead>
								<tr>
									<th class="link-existing-col-check"></th>
									<th class="cursor-pointer" @click="sortExistingEvidence('filename')">
										<div class="flex table-header-label-wrap">
											<div class="table-header-label">TITLE</div>
											<div class="sort cursor-pointer" :class="existingEvidenceSortKey === 'filename' ? existingEvidenceSortClass : 'opacity-50'"></div>
										</div>
									</th>
									<th class="cursor-pointer" @click="sortExistingEvidence('sourceTaskId')">
										<div class="flex table-header-label-wrap">
											<div class="table-header-label">TASK ID</div>
											<div class="sort cursor-pointer" :class="existingEvidenceSortKey === 'sourceTaskId' ? existingEvidenceSortClass : 'opacity-50'"></div>
										</div>
									</th>
									<th class="cursor-pointer" @click="sortExistingEvidence('evidenceType')">
										<div class="flex table-header-label-wrap">
											<div class="table-header-label">TYPE</div>
											<div class="sort cursor-pointer" :class="existingEvidenceSortKey === 'evidenceType' ? existingEvidenceSortClass : 'opacity-50'"></div>
										</div>
									</th>
									<th class="cursor-pointer" @click="sortExistingEvidence('evidenceDate')">
										<div class="flex table-header-label-wrap">
											<div class="table-header-label">EVIDENCE DATE</div>
											<div class="sort cursor-pointer" :class="existingEvidenceSortKey === 'evidenceDate' ? existingEvidenceSortClass : 'opacity-50'"></div>
										</div>
									</th>
								</tr>
								<tr v-if="showExistingEvidenceFilters" class="link-existing-filter-row">
									<td class="link-existing-col-check"></td>
									<td><input type="text" class="searchForInputBoxStyling" v-model.trim="existingEvidenceFilters.filename" placeholder="Search" @click.stop /></td>
									<td><input type="text" class="searchForInputBoxStyling" v-model.trim="existingEvidenceFilters.sourceTaskId" placeholder="Search" @click.stop /></td>
									<td><input type="text" class="searchForInputBoxStyling" v-model.trim="existingEvidenceFilters.evidenceType" placeholder="Search" @click.stop /></td>
									<td></td>
								</tr>
							</thead>
							<tbody v-if="filteredSortedExistingEvidences.length">
								<tr v-for="row in filteredSortedExistingEvidences" :key="row.optionKey">
									<td class="link-existing-col-check">
										<input type="checkbox" :checked="isExistingEvidenceSelected(row)" @change="toggleExistingEvidence(row)" />
									</td>
									<td :title="row.filename">{{ row.filename }}</td>
									<td>{{ row.sourceTaskId }}</td>
									<td>{{ existingEvidenceTypeLabel(row) }}</td>
									<td>{{ row.evidenceDate ? formatFileAttachedTime(row.evidenceDate) : 'N/A' }}</td>
								</tr>
							</tbody>
							<tbody v-else>
								<tr>
									<td class="link-existing-empty" colspan="5">No Records Found</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="link-existing-actions">
					<button type="button" class="link-existing-cancel" @click="closeLinkEvidencePopup">Cancel</button>
					<button type="button" class="link-existing-save" @click="saveLinkedEvidence" :class="selectedExistingEvidences.length === 0 ? 'link-existing-save-disabled' : ''">Save</button>
				</div>
			</div>
		</div>
	</div>
</template>
<style scoped>
.completedBox{
	background-color: #00B050 !important;
	font-weight:600 !important;
	color: white;
	pointer-events: none;
}
.bgdarkred{
 background-color: rgba(192, 0, 0, 0.2);
}
.selectIcon :deep(.p-select-dropdown){
	display: none;
}
.taskStatusOptions{
  background-color: white; 
  color: rgba(77, 77, 77, var(--tw-text-opacity))
 }
 .taskStatusOptionsForNotStarted{
   background-color: #e9e9e9; 
   color: rgba(77, 77, 77, var(--tw-text-opacity))
 }
 .numberBorder{
    border-top: 1px solid #e9e9e9;
    border-right: 1px solid #e9e9e9;
    border-bottom: 1px solid #e9e9e9;
}
.numberNavy{
    border-left: 1px solid #152A43;
    border-width: 2px;
}
.widthForCommentBox{
	width : 75px;
}
.progressbarB {
	border: 2px solid #e9e9e9;
	background: #e9e9e9;
	position: relative;
	top: -8px;
	z-index: 1;
}
.numberBorder{
    border-top: 1px solid #e9e9e9;
    border-right: 1px solid #e9e9e9;
    border-bottom: 1px solid #e9e9e9;
}
.numberNavy{
    border-left: 1px solid #152A43;
    border-width: 2px;
}
.progress {
	background: #1976d2;
	position: relative;
	border-radius: 4px;
	z-index: 2;
}
.primaryBackground{
	background-color: #1976d233
}
.descriptionToggle {
	height: 97%;
}
.tabStructure {
	height: calc(100vh - 165px);
}
.thirtyWidthToggle::-webkit-scrollbar {
	width: 0 !important;
	height: 0 !important;
	background: transparent;
}

.thirtyWidthToggle::-webkit-scrollbar-thumb {
	background: transparent;
}
.thirtyWidthToggle{  
     height:  calc(100vh - 250px);
}
.descriptionToggle::-webkit-scrollbar {
	width: 0 !important;
	height: 0 !important;
	background: transparent;
}

.descriptionToggle::-webkit-scrollbar-thumb {
	background: transparent;
}
.heightFixing {
	height:  calc(100vh - 220px);
	/* height : 64vh; */
}
.task-details-in-modal .tabStructure,
.task-details-in-modal .heightFixing,
.task-details-in-modal .thirtyWidthToggle,
.task-details-in-modal .descriptionToggle {
	height: 100% !important;
	max-height: 100% !important;
}
.task-details-in-modal .descriptionToggle,
.task-details-in-modal .thirtyWidthToggle {
	overflow-y: auto !important;
	scrollbar-width: thin;
	scrollbar-color: #a4a4a4 transparent;
}
.task-details-in-modal .descriptionToggle::-webkit-scrollbar,
.task-details-in-modal .thirtyWidthToggle::-webkit-scrollbar {
	width: 6px !important;
	height: 6px !important;
	display: block !important;
	background: transparent !important;
}
.task-details-in-modal .descriptionToggle::-webkit-scrollbar-track,
.task-details-in-modal .thirtyWidthToggle::-webkit-scrollbar-track {
	background: transparent !important;
}
.task-details-in-modal .descriptionToggle::-webkit-scrollbar-thumb,
.task-details-in-modal .thirtyWidthToggle::-webkit-scrollbar-thumb {
	background: #a4a4a4 !important;
	border-radius: 4px;
}
option {
	background-color: #ffffff;
	color: #000000;
	border-color: pink transparent transparent transparent;
}
.textColorWhite {
	color: white;
}
.w-20{
	width : 20%;
}
.w-80{
	width : 80%;
}
.twopxtop{
   margin-top : 5px;
}
.selectCustom {
	/* background-image: url("data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.65166 4.18411C1.39599 4.28576 1.20193 4.46133 1.07564 4.69852C0.980151 4.88334 0.97399 5.35463 1.06332 5.54561C1.14957 5.72734 8.24662 12.8275 8.44068 12.926C8.56081 12.9876 8.62857 13 8.875 13C9.12143 13 9.18919 12.9876 9.30932 12.926C9.50338 12.8275 16.6004 5.72734 16.6867 5.54561C16.776 5.35463 16.7698 4.88334 16.6744 4.69852C16.5789 4.5137 16.3879 4.32272 16.2123 4.23339L16.0675 4.15946L8.9058 4.1533C3.46597 4.15022 1.72251 4.15638 1.65166 4.18411Z' fill='%234D4D4D'/%3E%3C/svg%3E"); */
	background-repeat: no-repeat no-repeat;
	background-position: center center;
	background-size: 12px 12px;
	background-position: right 6px center; /* Change the px value here to change the distance */
	-moz-appearance: none;
	-webkit-appearance: none;
	appearance: none;
}
.custom-select {
    background-image: url("../assets/Collapse.svg") !important;
    background-repeat: no-repeat no-repeat;
    background-position: center center;
    background-size: 12px 12px;
    background-position: right 15px center; /* Change the px value here to change the distance */
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
}
.marginBottomForDoc{
	margin-bottom : 3px;
}
.marginTopForDoc{
	margin-top : 2.5px;
}
.marginBottomZero{
	margin-bottom : 0px;
}
.pendingEvidence{
    background-color: #8600f040;
}
.evidenceUpload{
    background: rgba(25,118,210,0.24);
}
.labelWidth{
	min-width: 7rem;
}
.framework{
	padding: 12px 170px 12px 12px;
}
.findingCategory{
	padding: 12px 80px 12px 12px;
}
.tabHeaderText{
	color: #1976d2;
}
.inputboxstyling1 {
  display: block;
  width: 100%;
  border-radius: 0.25rem;
  border-width: 1px;
  border-style: solid;
  --tw-border-opacity: 1;
  border-color: rgba(233, 233, 233, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  /* background-color: rgba(255, 255, 255, var(--tw-bg-opacity)); */
  padding-left: 0.625rem;
  padding-right: 0.625rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.875rem;
  /* line-height: 1.25rem; */
  font-weight: 300;
  --tw-text-opacity: 1;
  /* color: rgba(77, 77, 77, var(--tw-text-opacity)); */
}
.btnprimary1 {
	cursor: pointer;
	border-bottom-right-radius: 0.25rem;
	border-top-right-radius: 0.25rem;
	--tw-bg-opacity: 1;
	background-color: rgba(21, 42, 67, var(--tw-bg-opacity));
	padding-left: 0.625rem;
	padding-right: 0.625rem;
	padding-top: 0.625rem;
	padding-bottom: 0.625rem;
	/* font-family: Open Sans; */
	font-size: 0.875rem;
	/* line-height: 1.25rem; */
	font-weight: 700;
	/* line-height: 0.75rem; */
	--tw-text-opacity: 1;
	color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.heightForDiv{
height : 29.333px;
padding-left: 0.625rem;
padding-right: 0.625rem;
padding-top: 0.25rem;
padding-bottom: 0.25rem;
}
:deep(.p-select.p-disabled.bg-disabledgrey),.bg-disabledgrey{
  background-color: #a4a4a4 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-yellow),.bg-yellow{
  background-color: #FF9900 !important;
  font-weight: 600 !important;
}
.p-select.p-disabled .p-select-dropdown{
  background-color: #a4a4a4 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-electricGreen),.bg-electricGreen{
  background-color: #8600F0 !important;
  font-weight: 600 !important;
}
:deep(.p-select.pendingEvidence-status),
.pendingEvidence-status,
:deep(.p-select.p-disabled.pendingEvidence-status) {
  background-color: #8600f040 !important;
  border: 1px solid #8600F0 !important;
  font-weight: 600 !important;
}
:deep(.p-select.pendingEvidence-status .p-select-label) {
  color: #8600F0 !important;
}
:deep(.p-select.p-disabled.bg-lightgreen),.bg-lightgreen{
  background-color: #00B050 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-darkred),.bg-darkred{
  background-color: #C00000 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-forReview),.bg-forReview{
  background-color: #085B96 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-error),.bg-error{
  background-color: #FF0000 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-primary),.bg-primary{
  background-color: #1976D2 !important;
  font-weight: 600 !important;
}
:deep(.p-select-label){
  color: white !important;
}
:deep(.p-select.p-disabled .p-select-label){
  color: white !important;
}
:deep(.p-select.p-disabled .p-select-dropdown) {
  display: none !important;
}
:deep(.p-select.p-disabled){
	opacity: 1 !important;
}

:deep(.p-select-dropdown-icon){
  color: white !important;
}
/* :deep(.p-select-dropdown){
	display: none;
} */
</style>
<script lang="ts">
import { defineComponent, toRaw } from 'vue';
import breadCrumbs from '@/components/breadCrumbs.vue';
import { helpers,required, requiredIf } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import popup from '@/components/popup.vue';
import { groupBy } from 'lodash';
import { emitter, toast } from '@/main';
import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { v4 as uuidv4 } from 'uuid';
import commentsEditor from '@/components/commentsEditor.vue';
import Multiselect from 'vue-multiselect';
import safeHtml from "@/components/safeHtml.vue";
import dotsLoader from '@/components/dotsLoader.vue';
import pagination from '@/components/pagination.vue';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import Select from 'primevue/select';
import AutoComplete from 'primevue/autocomplete';
const restrictCharacters20 = helpers.regex(/^.{0,20}$/);
const restrictCharacters50 = helpers.regex(/^.{0,50}$/);
const restrictCharacters60 = helpers.regex(/^.{0,60}$/);
const httpUrl = (value: string) => {
	if (!value) return true;
	try {
		const parsed = new URL(value);
		return parsed.protocol === 'http:' || parsed.protocol === 'https:';
	} catch {
		return false;
	}
};

export default defineComponent({
	props: {
		findingId: { type: [String, Number], default: null },
		taskId: { type: [String, Number], default: null },
		modalMode: { type: Boolean, default: false },
	},
	emits: ['header-info', 'open-nested'],
	data(): any {
		return {
			v$: useVuelidate(),
			fileToUpload: null,
			selectedTabIndex: 1,
			tabHead: [
				{ displayName: 'Description', id: 1 },

				{ displayName: 'Documents', id: 2 },

				{ displayName: 'Evidence', id: 3 },

				{ displayName: 'Comments', id: 4 },

				{ displayName: 'Approvals', id: 5 },

				{ displayName: 'History', id: 6 }
			],
			routesArray: [],
			// navIndexNums: { name: '', index: '' },
			selectedControlNumbers:[],
			TaskDetailsDropDown: {
				taskStatus: '',
				assignedToDropDown: ''
			},
			assignedToList:[],
			presentFindingObject:[],
			userOptions:[],
			tabDataLoading:false,
			newTeamAssignee: '',
			taskStatusData: [],
			allCapaStatuses: [],
			auditorTaskData:[],
			findingCategoryData: [
				{
					id: 1,
					value: 'Minor'
				},
				{
					id: 2,
					value: 'Major'
				},
				{
					id: 3,
					value: 'OFI'
				},
				{
					id: 4,
					value: 'Observation'
				}
			],
			controlRiskSeverityLabelOptions: [],

			assignedToData: [
				{
					id: 1,
					name: 'Nikhil Kapuganti'
				},
				{
					id: 2,
					name: 'Abhiram Kadari'
				},
				{
					id: 3,
					name: 'Venkatesh Abisetty'
				}
			],
			oldComments: true,
			newHistory: true,
			comment: '',
			comments: [],
			btnDisabled: true,
			showPopUp: false,
			findingsObject: {
				findingId:'',
				frameworks: '',
				frameWorkControl:'',
				findingCategory: '',
				findingComment: '',
				findingEvidence: '',
				auditResult: ''
			},
			taskObj:{
                approvalComments : ''
            },
			findingsObjectDummy: {},
			presentAuditData: {},
			selectedOption: '',
			selectedBG: '',
			workLogObject: [],
			optionsUserArray: [],
			orgUsersList: [],
			presentAuditObject: {},
			tasksForAudit: [],
			presentTaskObject: {},
			dummyPresentTaskObject:{},
			personObj : '',
			controlsArray : [],
			controlDetailsArray : [],
            controlsArrayAllControls : [],
            controlsDetailsList : [],
			teamObj : '',
            selectedTabObj:{},
            users : [],
			allFrameWorkControls:[],
			locationObject:[],
			importpopUp: false,
			evidenceAttachMode: 'file',
			evidenceUrl: '',
			linkSortKey: '',
			linkSortDir: 'asc',
			linkCurrentPage: 1,
			linkPageSize: 10,
			isInputFileNameValid: true,
			fileSelected: false,
			isFileValid: true,
			inputFileName: '',
			fileChanged : false,
			fileName:'',
			evidenceDate:'',
			showDeleteEvidenceConfirm: false,
			deleteEvidenceIndex: null,
			linkEvidencePopup: false,
			linkEvidenceTasks: [],
			selectedExistingEvidences: [],
			existingEvidenceSortKey: '',
			existingEvidenceSortDir: 'asc',
			showExistingEvidenceFilters: false,
			existingEvidenceFilters: { filename: '', sourceTaskId: '', evidenceType: '', evidenceDate: '' },
			findingsForTask:[],
			allTasks: [],
			presentFindingTaskObj:{},
			showApprovalPopup: false,
			approvalObj : {},
			enableApproveAndReject : false,
			approvalSent : {},
			 normalJustification:{
				justification : ''
			},
			showRejectPopupForNormalApproval : false,
			showRejectPopupAtInReview : false,
			finalJustification:{
				justification : ''
			},
			clickOnButton:false,
			clickOnButtonForApproval : false,
			clickOnButtonForApproveOrReject:false,
			clickOnButtonForInProgress : false,
			searchValue:'',
			placeholder: 'Select a File',
			disabledStatuses:[],
			dotsLoading:true
		};
	},
	validations() {
		return {
			inputFileName:{
				required,
				restrictCharacters50: function (this: any, value: string) {
					if (this.evidenceAttachMode !== 'file') return true;
					return restrictCharacters50(value);
				},
				restrictCharacters60: function (this: any, value: string) {
					if (this.evidenceAttachMode !== 'url') return true;
					return restrictCharacters60(value);
				}
			},
			fileToUpload: {
				required: requiredIf(function (this: any) {
					return this.evidenceAttachMode === 'file';
				})
			},
			evidenceUrl: {
				required: requiredIf(function (this: any) {
					return this.evidenceAttachMode === 'url';
				}),
				httpUrl
			},
			evidenceDate:{required},
			findingsObject: {
				findingId:{required},
				frameworks: { required },
				frameWorkControl:{required},
				findingCategory: { required },
				findingComment: { required },
				findingEvidence: { required }
				// auditResult: { required }
			}
		};
	},
	components: {
		breadCrumbs,
		popup,
		Multiselect,
		commentsEditor,
		safeHtml,
		dotsLoader,
		pagination,
		Tabs,
		Tab,
		TabList,
		TabPanels,
		TabPanel,
		Select,
		AutoComplete

	},
	computed: {
		...mapGetters({ userInfo: 'userInfo' }),
		currentFindingId(): any {
			return this.findingId || this.$route.params.findingId;
		},
		currentTaskId(): any {
			return this.taskId || this.$route.params.taskId;
		},
		todayDate() {
			return new Date().toISOString().split('T')[0];
		},
		isEvidenceSaveDisabled(): boolean {
			if (this.evidenceAttachMode === 'url') {
				return this.inputFileName.length === 0 && this.evidenceUrl.length === 0 && this.evidenceDate.length === 0;
			}
			return this.inputFileName.length === 0 && this.evidenceDate.length === 0;
		},
		fileEvidences(): any[] {
			const files = this.presentFindingTaskObj?.files;
			if (!Array.isArray(files)) return [];
			return files.filter((doc: any) => (doc?.evidenceType || 'file') !== 'url');
		},
		linkEvidences(): any[] {
			const files = this.presentFindingTaskObj?.files;
			if (!Array.isArray(files)) return [];
			return files.filter((doc: any) => doc?.evidenceType === 'url');
		},
		pastYearExistingEvidences(): any[] {
			const currentId = String(this.currentTaskId || '');
			const currentUrls = new Set((this.presentFindingTaskObj?.files || []).map((doc: any) => doc?.url).filter((url: any) => !!url));
			const userId = String(this.userInfo?._id || '');
			const now = new Date();
			const oneYearAgo = new Date();
			oneYearAgo.setFullYear(now.getFullYear() - 1);
			const rows: any[] = [];
			const seen = new Set<string>();
			const originalOwnerByUrl = new Map<string, string>();
			(this.linkEvidenceTasks || []).forEach((task: any) => {
				if (!Array.isArray(task?.files)) return;
				task.files.forEach((doc: any) => {
					if (!doc?.url || doc.linkedEvidenceTaskId == null || String(doc.linkedEvidenceTaskId) === '') return;
					originalOwnerByUrl.set(String(doc.url), String(doc.linkedEvidenceTaskId));
				});
			});
			(this.linkEvidenceTasks || []).forEach((task: any) => {
				if (String(task?._id || '') === currentId || !Array.isArray(task?.files)) return;
				const sourceTaskId = task.taskId != null && String(task.taskId) !== '' ? String(task.taskId) : '';
				if (!sourceTaskId) return;
				task.files.forEach((doc: any) => {
					if (!doc?.url || currentUrls.has(doc.url)) return;
					if (doc.taskId != null && String(doc.taskId) !== '' && String(doc.taskId) !== sourceTaskId) return;
					if (doc.linkedEvidenceTaskId != null && String(doc.linkedEvidenceTaskId) !== '') return;
					const originalOwner = originalOwnerByUrl.get(String(doc.url));
					if (originalOwner && originalOwner !== sourceTaskId) return;
					if (String(doc.createdBy || '') !== userId) return;
					const filename = doc.filename || doc.name;
					if (!filename) return;
					const evidenceTime = Date.parse(doc.evidenceDate);
					if (isNaN(evidenceTime) || evidenceTime < oneYearAgo.getTime() || evidenceTime > now.getTime()) return;
					const optionKey = `${sourceTaskId}|${doc.url}`;
					if (seen.has(optionKey)) return;
					seen.add(optionKey);
					rows.push({
						...doc,
						filename,
						sourceTaskId,
						optionKey
					});
				});
			});
			return rows;
		},
		existingEvidenceSortClass(): string {
			return this.existingEvidenceSortDir === 'asc' ? 'sort_desc' : 'sort_asc';
		},
		filteredSortedExistingEvidences(): any[] {
			const filters = this.existingEvidenceFilters || {};
			const rows = (this.pastYearExistingEvidences || []).filter((row: any) => {
				const title = String(row.filename || '').toLowerCase();
				const taskId = String(row.sourceTaskId || '').toLowerCase();
				const typeLabel = this.existingEvidenceTypeLabel(row).toLowerCase();
				if (filters.filename && !title.includes(String(filters.filename).toLowerCase())) return false;
				if (filters.sourceTaskId && !taskId.includes(String(filters.sourceTaskId).toLowerCase())) return false;
				if (filters.evidenceType && !typeLabel.includes(String(filters.evidenceType).toLowerCase())) return false;
				return true;
			});
			const key = this.existingEvidenceSortKey;
			if (!key) return rows;
			const modifier = this.existingEvidenceSortDir === 'desc' ? -1 : 1;
			return rows.sort((a: any, b: any) => {
				if (key === 'evidenceDate') {
					const aTime = Date.parse(a?.evidenceDate);
					const bTime = Date.parse(b?.evidenceDate);
					if (aTime < bTime) return -1 * modifier;
					if (aTime > bTime) return 1 * modifier;
					return 0;
				}
				if (key === 'sourceTaskId') {
					const aVal = String(a?.sourceTaskId || '');
					const bVal = String(b?.sourceTaskId || '');
					const aNumMatch = aVal.match(/\d+$/);
					const bNumMatch = bVal.match(/\d+$/);
					if (aNumMatch && bNumMatch) {
						const aNum = parseInt(aNumMatch[0], 10);
						const bNum = parseInt(bNumMatch[0], 10);
						if (aNum < bNum) return -1 * modifier;
						if (aNum > bNum) return 1 * modifier;
						return 0;
					}
					if (aVal < bVal) return -1 * modifier;
					if (aVal > bVal) return 1 * modifier;
					return 0;
				}
				const aVal = key === 'evidenceType' ? this.existingEvidenceTypeLabel(a) : String(a?.filename || '');
				const bVal = key === 'evidenceType' ? this.existingEvidenceTypeLabel(b) : String(b?.filename || '');
				if (aVal.toLowerCase() < bVal.toLowerCase()) return -1 * modifier;
				if (aVal.toLowerCase() > bVal.toLowerCase()) return 1 * modifier;
				return 0;
			});
		},
		findingFileEvidences(): any[] {
			const files = this.presentFindingObject?.[0]?.files;
			if (!Array.isArray(files)) return [];
			return files.filter((doc: any) => (doc?.evidenceType || 'file') !== 'url');
		},
		findingLinkEvidences(): any[] {
			const files = this.presentFindingObject?.[0]?.files;
			if (!Array.isArray(files)) return [];
			return files.filter((doc: any) => doc?.evidenceType === 'url');
		},
		linkSortClass(): string {
			return this.linkSortDir === 'asc' ? 'sort_desc' : 'sort_asc';
		},
		sortedLinkEvidences(): any[] {
			const rows = [...this.linkEvidences];
			const key = this.linkSortKey;
			if (!key) {
				return rows;
			}
			const dir = this.linkSortDir === 'asc' ? 1 : -1;
			return rows.sort((a: any, b: any) => {
				let aVal = '';
				let bVal = '';
				if (key === 'evidenceDate') {
					aVal = a?.evidenceDate || '';
					bVal = b?.evidenceDate || '';
				} else if (key === 'url') {
					aVal = a?.url || '';
					bVal = b?.url || '';
				} else if (key === 'taskId') {
					aVal = a?.taskId || '';
					bVal = b?.taskId || '';
				} else {
					aVal = a?.filename || a?.name || '';
					bVal = b?.filename || b?.name || '';
				}
				return String(aVal).localeCompare(String(bVal), undefined, { sensitivity: 'base' }) * dir;
			});
		},
		filteredLinkCount(): number {
			return this.sortedLinkEvidences.length;
		},
		paginatedLinkEvidences(): any[] {
			const start = (this.linkCurrentPage - 1) * this.linkPageSize;
			const end = this.linkCurrentPage * this.linkPageSize;
			return this.sortedLinkEvidences.slice(start, end);
		},
		linkTableResizeStyle(): any {
			return {
				tableLayout: 'fixed',
				width: '100%',
				maxWidth: '100%',
			};
		},
	},
	watch: {
		presentFindingTaskObj: {
			handler(obj: any) {
				if (this.modalMode && obj && (obj.action || obj.taskId)) {
					this.$emit('header-info', { title: obj.action || obj.taskId });
				}
			},
			deep: true,
		},
	},
	methods: {
		onClickToRejectByJustificationAtInReview(){
		   this.showRejectPopupAtInReview = true;
		},
		onCrossBtnForFinalApproval(){
			this.showRejectPopupAtInReview = false;
			this.finalJustification.justification = '';
		},
		onCancelbtnForFinalApproval(){
	       this.onCrossBtnForFinalApproval();
	    },
		clickToRejectByJustification(){
			this.showRejectPopupForNormalApproval = true;
		},
		colorForDueDate(date: any) {
			if (!date) return '';
			const due = new Date(date);
			if (isNaN(due.getTime())) return '';
			const today = new Date();
			due.setHours(0, 0, 0, 0);
			today.setHours(0, 0, 0, 0);
			
			if (due < today) {
			return ["bgdarkred border-solid border text-darkred font-semibold flex justify-center items-center text-xs"]
			}
			return '';
		},
		async updateTaskDueDate(type:any,dueDate:any){
			let now = new Date();
            let selectedDate = new Date(dueDate);
            selectedDate.setHours(
                now.getHours(),
                now.getMinutes(),
                now.getSeconds(),
                now.getMilliseconds()
            );
			let payload:any={dueDate:selectedDate}
			await this.updateFindingTask(8,payload)
		},
		 onCancelbtnForNormalApproval(){
			this.onCrossBtnForNormalApproval();
		},
		formatDate(time: any) {
			return moment(time).format("DD-MM-YYYY");
		},
		 onCrossBtnForNormalApproval(){
			this.showRejectPopupForNormalApproval = false;
			this.normalJustification.justification = '';
		},
		openCalendar(event: any) {
			event.target.showPicker();
		},
		getBorder(){
            return `numberBorder numberNavy`
        },
		filterTaskStatusData(data: any) {
			const startId = 10414;
			const endId = 10403;
			return data.filter((item:any) => item.id >= startId && item.id <= endId);
		},
		 isAddDisabled(permission:any) {
			try {
				if (!this.userInfo || !this.userInfo.organisationType) {
					return true;
				}
				// if (this.userInfo.organisationType !== 10701) {
				// 	return true; 
				// }
				return this.hasPermission(this.userInfo, 10006, 10121, permission);
			} catch (e) {
				return true;
			}
	  	},
		formatFileAttachedTime(time: any) {    
			let now = moment(time);
			return now.format("DD-MM-YYYY");
		},
		getS3KeyFromUrl(fileUrl: string) {
			try {
				const url = new URL(fileUrl);
				return url.pathname.startsWith('/')
				? url.pathname.slice(1)
				: url.pathname;
			} catch (e) {
				return '';
			}
		},

		getEvidenceFileExt(doc: any) {
			if (!doc?.url || doc.evidenceType === 'url') return '';
			try {
				const path = new URL(doc.url).pathname;
				return (path.split('.').pop() || '').toLowerCase();
			} catch {
				return (String(doc.url).split('.').pop() || '').toLowerCase();
			}
		},
		async openEvidenceFile(doc: any) {
			const fileUrl = typeof doc === 'string' ? doc : doc?.url;
			if (!fileUrl) return;

			if (typeof doc !== 'string' && doc?.evidenceType === 'url') {
				window.open(fileUrl, '_blank', 'noopener,noreferrer');
				return;
			}

			const key = this.getS3KeyFromUrl(fileUrl);
			if (!key) {
				return;
			}

			try {
				const response = await this.$http.post(
				`${process.env.VUE_APP_FILE_API}/presignedurl/v3`,
				{ key }
				);

				const signedUrl =
				typeof response.data === 'string'
					? response.data
					: response.data?.url;

				if (signedUrl) {
				window.open(signedUrl, '_self');
				}
			} catch (err) {
				console.error(err);
			}
		},
		sortLinkEvidences(key: string) {
			if (this.linkSortKey === key) {
				this.linkSortDir = this.linkSortDir === 'asc' ? 'desc' : 'asc';
			} else {
				this.linkSortKey = key;
				this.linkSortDir = 'asc';
			}
			this.linkCurrentPage = 1;
		},
		onLinkPaginationUpdate(currentPage: any, pageSize: any) {
			this.linkCurrentPage = currentPage;
			this.linkPageSize = pageSize;
		},
		async getPresentFindingObject() {
			if (!this.currentFindingId) {
				this.presentFindingObject = [];
				return;
			}
			try {
				const result = await this.$http.get(`${process.env.VUE_APP_AUDIT_API}/api/org/finding/${this.currentFindingId}/get`);
				const data = result.data;
				this.presentFindingObject = Array.isArray(data) ? data : (data ? [data] : []);
			} catch {
				this.presentFindingObject = [];
			}
		},
		hasPermission(userInfo:any, appId:any, entityId:any, permissionId:any) {
			if (!userInfo || !userInfo.apps) return false;
			const app = userInfo.apps.find((a:any) => a.appId === appId);
			if (!app) return false;

			const entity = app.entities?.find((e:any) => e.entityId === entityId);
			if (!entity) return false;

			return entity.permissions?.includes(permissionId) || false;
		},
		limitText (count:any) {
			// return `and ${count} other countries`
			// console.log('countcount',count)
		},
		asyncFind(query:any){
			query=query.query
			this.searchValue = query;
			if(query == ''){
				this.userOptions = []
			}else if(query.length > 0){
				this.userOptions = this.assignedToList.filter((obj:any)=>{ return obj.label.toLowerCase().includes(query.toLowerCase()) && obj.value != this.presentFindingTaskObj.auditor && obj.value!=this.userInfo._id })
			}
		},
		asyncFindApprovals(query:any){
			query=query.query
			this.searchValue = query;
			if(query == ''){
				this.userOptions = []
			}else if(query.length > 0){
				this.userOptions = this.optionsUserArray.filter((obj:any)=>{ return obj.label.toLowerCase().includes(query.toLowerCase()) && obj.value != this.presentFindingTaskObj.auditor && obj.value!=this.userInfo._id })
			}
		},
		onCancelbtnAtApproval(){
				this.taskObj.approvalComments = '';
		},
		openApprovalpopup(){
            this.showApprovalPopup = true;
        },
		onCrossbtn(){
			this.showApprovalPopup = false;
			this.taskObj.approvalComments = '';
			
		},
		async ApprovalforInprogress(statusCode: any){
			this.clickOnButtonForInProgress = true;
            const payload: any = {
				action: 10302,
                statusCode:statusCode,
                updatedAt: moment().format('YYYY-MM-DD HH:mm:ss'),
                updatedBy:this.userInfo._id
 
            };
 
            try{
				await this.$http
                .post(`${process.env.VUE_APP_AUDIT_API}/api/org/capa-task/${this.currentTaskId}/update/approval`,payload)
                .then((result: { data: any }) => {
                //    console.log('Result',result.data)
                })
                if(statusCode == 10403){
                toast.success(`Approval Approved`, {
                        timeout: 1000,
                        closeOnClick: true,
                        closeButton: 'button',
                        icon: true
                });
				}else if(statusCode == 10410){
					toast.error(`Approval Rejected`, {
							timeout: 1000,
							closeOnClick: true,
							closeButton: 'button',
							icon: true
					});
				
				}
				this.enableApproveAndReject = false
				await this.getAllFindingTasks()
				this.onCrossBtnForFinalApproval()
			} catch (e) {
				toast.error(`Something went wrong`, {
				timeout: 1000,
				closeOnClick: true,
				closeButton: "button",
				icon: true,
				});
			} finally {
				this.clickOnButtonForInProgress = false;
			}
        },
        async clickOnSaveForApproval() {
			this.clickOnButtonForApproval = true;
            this.showApprovalPopup = false;
			let approvalSents:any = _.cloneDeep(this.approvalSent);
            const payload: any = {
                approver: approvalSents.value,
                comments: this.taskObj.approvalComments,
				createdBy: this.userInfo._id,
                createdAt: moment().format('YYYY-MM-DD HH:mm:ss'),
                
            };
			await this.updateFindingTask(6,payload)
            await this.getAllFindingTasks()
            this.taskObj.approvalComments = '';
			this.enableApproveAndReject = true
       },
		checkKey(obj: any,key: any){
			if(obj == '' || obj == undefined){
				return false
			}else{
				const keys: any = Object.keys(obj)
				for (let i = 0; i < keys.length; i++) {
					if (keys[i] === key) {
						return true;
					}
				}
				return false;
			}
		},
		
		async approveOrRejectForActionTasktoComplete(statusCode : any,type :any){
			this.clickOnButtonForApproveOrReject = true;
            
            const payload: any = {
				action: 10302,
                statusCode:statusCode,
                createdAt: moment().format('YYYY-MM-DD HH:mm:ss'),
                createdBy:this.userInfo._id
            };
            try{
				await this.$http
				.post(`${process.env.VUE_APP_AUDIT_API}/api/org/capa-task/${this.currentTaskId}/type/${type}/update`,payload)
				.then((result: { data: any }) => {
                //    console.log('here it ISSSSSS',result.data)
                })
            if(statusCode == 10403){
                toast.success(`Approval Approved`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
				});
				await this.getFindingTaskHistoryObject()
            }else if(statusCode == 10401){
                toast.error(`Approval Rejected`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
				});
				if(this.disabledStatuses && this.disabledStatuses.length>0) {                  
                    this.disabledStatuses = [];
                }
				await this.getFindingTaskHistoryObject() 
            }
            await this.getAllFindingTasks()
			 this.onCrossBtnForNormalApproval()
			}catch (e) {
				toast.error('error', {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			} finally {
			    this.clickOnButtonForApproveOrReject = false;
			}
            
        },
		async getFindingTaskHistoryObject() {
			let taskId = this.currentTaskId;
			try {
				await this.$http.get(`${process.env.VUE_APP_AUDIT_API}/api/org/capa-task/${taskId}/getHistory`).then((result: any) => {
					this.workLogObject = result.data || { taskHistory: [] };
				});
			} catch {
				this.workLogObject = { taskHistory: [] };
			}
			this.workLogObject?.taskHistory?.sort().reverse();
		},
		
		getCategory(num: any) {
			let result = this.findingCategoryData.find((obj: any) => {
				return obj.id == num;
			});
			return result.value;
		},
		async loadFindingSeverityLabelOptions() {
			const valuesOf = (result: any) => {
				const values = result?.data?.[0]?.values;
				return Array.isArray(values) ? values : [];
			};
			try {
				const risk = await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/label/20420/getall`);
				this.controlRiskSeverityLabelOptions = valuesOf(risk).filter((item: any) =>
					item && String(item.key).toUpperCase() !== 'N/A' && Number(item.value) !== 0
				);
			} catch (error) {
				this.controlRiskSeverityLabelOptions = [];
			}
		},
		getFindingSeverityValue(obj: any) {
			const raw = obj?.finding_severity ?? obj?.findingSeverity;
			if (raw == null || raw === '') return null;
			if (typeof raw === 'object') {
				const nested = raw.value != null && raw.value !== '' ? Number(raw.value) : NaN;
				return Number.isFinite(nested) && nested > 0 ? nested : null;
			}
			const numeric = Number(raw);
			return Number.isFinite(numeric) && numeric > 0 ? numeric : null;
		},
		getFindingSeverityLabel(obj: any) {
			const raw = obj?.finding_severity ?? obj?.findingSeverity;
			if (raw == null || raw === '') return 'N/A';
			if (typeof raw === 'object' && raw.label != null && String(raw.label).trim() !== '') {
				return String(raw.label);
			}
			const value = this.getFindingSeverityValue(obj);
			const match = (this.controlRiskSeverityLabelOptions || []).find((item: any) => Number(item.value) === Number(value));
			return match?.key != null ? String(match.key) : 'N/A';
		},
		isDisabledFindingSeverityLabel(label: any) {
			const text = String(label || '').trim().toUpperCase();
			return text === 'N/A' || text === 'NONE';
		},
		findingSeverityChipBg(obj: any) {
			const label = this.getFindingSeverityLabel(obj);
			if (this.isDisabledFindingSeverityLabel(label)) {
				return ['bg-lightgrey border-solid border border-lightgrey'];
			}
			const value = this.getFindingSeverityValue(obj);
			if (value == 1) return ['bg-veryLowColor border-solid border border-lightgreen'];
			if (value == 2) return ['bg-lowColor border-solid border border-green'];
			if (value == 3) return ['bg-moderateColor border-solid border border-yellow'];
			if (value == 4) return ['bg-highColor border-solid border border-error'];
			if (value == 5) return ['bg-veryHighColor border-solid border border-darkred'];
			return ['bg-lightgrey border-solid border border-lightgrey'];
		},
		findingSeverityChipText(obj: any) {
			const label = this.getFindingSeverityLabel(obj);
			if (this.isDisabledFindingSeverityLabel(label)) {
				return ['text-gray text-xs font-semibold'];
			}
			const value = this.getFindingSeverityValue(obj);
			if (value == 1) return ['text-lightgreen text-xs font-semibold'];
			if (value == 2) return ['text-green text-xs font-semibold'];
			if (value == 3) return ['text-yellow text-xs font-semibold'];
			if (value == 4) return ['text-error text-xs font-semibold'];
			if (value == 5) return ['text-darkred text-xs font-semibold'];
			return ['text-gray text-xs font-semibold'];
		},
		getLocationName(teamId:any) {
            let teamObj = this.users.find((obj: any) => {
                return obj._id == teamId;
            });
            if (teamObj == undefined) {
                return 'N/A';
            } else if(teamObj.entityType != undefined && teamObj.entityType == 20301) {
                return this.locationObject.find((l:any)=>l.entityType==1)?.label||'N/A'
            }else if(teamObj.entityType != undefined && teamObj.entityType == 20303){
				return teamObj.entityName?teamObj.entityDisplayName:'N/A'
			}else{
				return 'N/A';
			}
        },
		onCancelIcon(){
			this.resetEvidenceForm();
			this.importpopUp = false;
		},
		resetEvidenceForm(){
			this.clickOnButton = false;
			this.inputFileName = '';
			this.fileName = '';
			this.evidenceDate = '';
			this.evidenceUrl = '';
			this.evidenceAttachMode = 'file';
			this.fileToUpload = null;
			this.pdfValidation = false;
			this.isDragOver = false;
			if (this.$refs.fileInput) {
				this.$refs.fileInput.value = '';
			}
			this.v$.$reset();
		},
		getStatusLabel(num:any){
			let result = this.allCapaStatuses.find((obj:any)=>{return obj.id == num})
			if(result != null && result != undefined){
                return result.value
            }
			result = this.auditorTaskData.find((obj:any)=>{return obj.id == num})
			if(result != null && result != undefined){
				return result.value
			}
			result = this.taskStatusData.find((obj:any)=>{return obj.id == num})
			if(result != null && result != undefined){
                return result.value
            }
			if(num==10403){
				return 'Completed';
			}
		},
		async getCapaStatuses(){
			let appId='10006';
			let entityId='10119';
			await this.$http.get(`${process.env.VUE_APP_AUTH_API}/${appId}/${entityId}/statuses`).then((result: any) => {
				const allStatuses = result.data.statuses || [];

				this.allCapaStatuses = allStatuses.map((item: any) => ({
					id: item.id,
					value: item.label
				}));

				this.taskStatusData = allStatuses
					.filter((item: any) => [10401, 10402, 10408,10414].includes(item.id))
					.map((item: any) => ({ id: item.id, value: item.label }));

					this.auditorTaskData = allStatuses
					.filter((item: any) => [10414, 10421].includes(item.id))
					.map((item: any) => ({ id: item.id, value: item.label }));
			});
		},
		scrollTabIntoView(tabId : any) {
			this.$nextTick(() => {
				const tabElement = this.$el.querySelector(`.tab:nth-child(${tabId})`);
				if (tabElement) {
				tabElement.scrollIntoView({ behavior: 'smooth', inline: 'center' });
				}
			});
		},
		getTeamName(team: any) {
            let teamObj = this.users.find((obj: any) => {
                return obj._id == team;
            });
            if (teamObj == undefined) {
                return '';
            } else {
                return teamObj.displayName;
            }
        },
		colorFindingBg(status: any) {
			if (status == 10401) {
				return ['bg-lightgrey border-solid border border-disabledgrey'];
			} else if (status == 10415||status==10421) {
				return ['bg-moderateColor border-solid border border-yellow'];
			} else if (status == 10403) {
				return ['bg-veryLowColor border-solid border border-lightgreen'];
			} 
			// else if (status == 10415) {
			// 	return ['pendingEvidence border-solid border border-electricGreen'];
			// } 
			else if (status == 10402 ) {
				return ['pendingEvidence border-solid border border-electricGreen'];
			} else if (status == 10408) {
				return ['evidenceUpload border-solid border border-primary'];
			} else if (status == 10419|| status==10414) {
				return ['bg-forReviewBg border-solid border border-forReview'];
			}
    	},
		colorFindingText(status: any) {
			if (status == 10401) {
				return ['font-semibold text-xs text-disabledgrey'];
			} else if (status == 10415 || status==10421) {
				return ['font-semibold text-xs text-yellow'];
			} else if (status == 10403) {
				return ['font-semibold text-xs text-lightgreen'];
			}
			//  else if(status == 10414){
			// 	return ['font-semibold text-xs mx-2 text-electricGreen']
			// } 
			else if (status == 10402 ) {
				return ['font-semibold text-xs text-electricGreen'];
			} else if(status == 10408 ){
				return ['font-semibold text-xs mx-2 text-primary']
			}else if(status == 10419 || status == 10414){
				return ['font-semibold text-xs mx-2 text-forReview']
			}
		},
		checkAuditor(){			
			
			if (this.presentFindingTaskObj.reviewer == this.userInfo._id) {
				return true;
			}else if ((this.userInfo.role_id!=10217&& this.userInfo.roleId!=10217) && this.presentFindingTaskObj.statusCode==10401 ) {
				return false;
			}
			else if (this.userInfo.role_id!=10217 && this.userInfo.roleId!=10217 && this.presentFindingTaskObj.statusCode==10414 ) {
				return true;
			} else if(this.presentFindingTaskObj.auditor == undefined || this.presentFindingTaskObj.auditor == null){
				return 'N/A'
			} else {
				return false
			}
		},
		async getAllActiveUsers() {
			await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/active/getall`).then((res: any) => {
				this.orgUsersList = res.data;
				for (var i = 0; i < this.orgUsersList.length; i++) {
					if(this.orgUsersList[i].roleId!=10217){
						this.assignedToList.push({ label: this.orgUsersList[i].name, value: this.orgUsersList[i]._id });
					}
					this.optionsUserArray.push({ label: this.orgUsersList[i].name, value: this.orgUsersList[i]._id });
				}
			});
		},
		async getallEntities() {
            this.locationObject = []
			let result:any
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`).then((res: any) => {
                result = res.data;
            });
            for (var i = 0; i < result.length; i++) {
                this.locationObject.push({ label: result[i].entityDisplayName, value: result[i]._id ,entityType:result[i].entityType});
            }
        },
		async getAllTeams() {
            this.teamObject = []
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/departments/get`).then((res: any) => {
                this.users = res.data;
            });
            for (var i = 0; i < this.users.length; i++) {
                this.teamObject.push({ label: this.users[i].teamName, value: this.users[i]._id });
            }
        },
		getPersonName(person: any) {
			let personObj = this.orgUsersList.find((user: any) => {
				return user._id == person;
			});
			if (personObj == undefined && person==undefined) {
				return '';
			} else if(person!=undefined && personObj==undefined){								
				if(this.userInfo._id==person){					
					return this.userInfo.name;
				}
				else{
					return '';
				}
			}else {
				return personObj.name;
			}
		},
		getPerson(person: any) {
			this.personObj = this.orgUsersList.find((user: any) => {
              
				return user._id == person;
			});
			if (this.personObj == undefined) {
				return '';
			} else {
				return this.personObj.name;
			}
		},
		sortWorkLog() {
			this.newHistory = !this.newHistory;
			this.workLogObject?.taskHistory?.sort().reverse();
		},
		sortComments() {
			this.oldComments = !this.oldComments;
			if(this.presentFindingTaskObj.comments != undefined){
				this.presentFindingTaskObj.comments.sort().reverse();
			}
		},
		formatTime(time: any) {
			let now = moment(time);
			return now.format('DD-MM-YYYY, HH:mm:ss');
		},
		extractInitials(name: any) {
			const names = name.split(' ');
			return names
				.map((name: any) => name[0])
				.join('')
				.toUpperCase();
		},
		changeBackground() {
			if (this.TaskDetailsDropDown.taskStatus == 10401) {
				return 'bg-disabledgrey textColorWhite';
			} else if (this.TaskDetailsDropDown.taskStatus == 10415||this.TaskDetailsDropDown.taskStatus == 10421 ) {
				return 'bg-yellow textColorWhite';
			} else if (this.TaskDetailsDropDown.taskStatus == 10402) {
				return 'bg-electricGreen textColorWhite';
			} else if (this.TaskDetailsDropDown.taskStatus == 10408) {
				return 'bg-primary textColorWhite';
			} else if (this.TaskDetailsDropDown.taskStatus == 10403) {
				return 'bg-lightgreen textColorWhite';
			} else if (this.TaskDetailsDropDown.taskStatus == 10419 || this.TaskDetailsDropDown.taskStatus == 10414) {
                return 'bg-forReview';
            } else {
				return '';
			}
		},
		async updateTaskStatus(status: any) {
			if(this.presentFindingTaskObj!=undefined && this.presentFindingTaskObj.statusCode && this.presentFindingTaskObj.statusCode==status){
				return;
			}
			let payload: any = { statusCode: status };
			if(payload.statusCode==10414 &&(!this.presentFindingTaskObj.files || this.presentFindingTaskObj.files.length==0)){
				this.$nextTick(() => {
				this.TaskDetailsDropDown.taskStatus = this.presentFindingTaskObj.statusCode;
			});
				toast.error(`Add Evidence`, {
				timeout: 3000,
				closeOnClick: true,
				closeButton: "button",
				icon: true,
				});
			} 
			else{
				await this.updateFindingTask(4, payload);
			}
		},
		async updateAssignedMember(obj: any) {
			let payload: any = { assignee: obj.value };
			await this.updateFindingTask(5, payload);
			if(this.presentFindingTaskObj.assignee != undefined){
                this.newTeamAssignee = this.presentFindingTaskObj.assignee
            }
		},
		handleInput() {
			this.btnDisabled = this.comment.length === 0;
		},
		async addComment() {
			if (this.comment.trim() !== '') {
				const newComment: any = {
					comment: this.comment
				};
				await this.updateFindingTask(1, newComment);
				if(this.presentFindingTaskObj.comments != undefined){
					this.presentFindingTaskObj.comments.sort().reverse();
				}
				// this.comments.push(newComment);
				this.comment = '';
				this.btnDisabled = true;
			}
		},
		clearComment() {
			this.comment = '';
			this.btnDisabled = true;
		},
		async toggleTabs(obj: any) {
			this.tabDataLoading=true
            this.selectedTabIndex = obj.id;
            this.selectedTabObj = obj;
			// sessionStorage.setItem('selectedTab', obj.id);
			await this.getAllFindingTasks()
			await this.getFindingTaskHistoryObject()
			if (this.presentFindingTaskObj.statusCode == 10401) this.disabledStatuses = [];
            else if (this.presentFindingTaskObj.statusCode==10402) this.disabledStatuses = [10401];
            else if (this.presentFindingTaskObj.statusCode==10408) this.disabledStatuses = [10401, 10402];
            else if(this.presentFindingTaskObj.statusCode == 10414 ) this.disabledStatuses = [10401,10402,10408];
            else if(this.presentFindingTaskObj.statusCode == 10421) this.disabledStatuses = [10401,10402,10408,10414];
            else if(this.presentFindingTaskObj.statusCode == 10403) this.disabledStatuses = [10401,10402,10408,10414,10421]
            else this.disabledStatuses = [];
			this.tabDataLoading=false
		},
		showFindingPopup() {
			this.showPopUp = !this.showPopUp;
			
		},
		onCancelButtonAddPopUp() {
			this.showPopUp = false;
			this.onCancelbtn();
		},
		openFilePopup(mode: string = 'file') {
			this.resetEvidenceForm();
			this.evidenceAttachMode = mode === 'url' ? 'url' : 'file';
			this.importpopUp = true;
		},
		async handleUrlEvidenceSave() {
			this.v$.inputFileName.$touch();
			this.v$.evidenceUrl.$touch();
			this.v$.evidenceDate.$touch();
			if (this.v$.inputFileName.$invalid || this.v$.evidenceUrl.$invalid || this.v$.evidenceDate.$invalid) {
				return;
			}
			this.clickOnButton = true;
			this.importpopUp = false;
			try {
				const payload: any = {
					url: this.evidenceUrl,
					filename: this.inputFileName,
					evidenceDate: new Date(this.evidenceDate).toISOString(),
					evidenceType: 'url'
				};
				await this.updateFindingTask(3, payload);
				this.resetEvidenceForm();
			} catch (err) {
				console.error(err);
				toast.error(`Error`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
				this.resetEvidenceForm();
			} finally {
				this.clickOnButton = false;
			}
		},
		
		// handleFileUpload(event: any) {
        //     const file = this.$refs.fileInput.files[0];
        //     if (file) {
        //         this.fileName = file.name;
        //         this.fileToUpload = file
        //          const fileNameParts = file.name.split('.');
        //         // console.log('fileNameParts1',fileNameParts)
        //         fileNameParts.pop(); // Remove the extension
        //         // console.log('fileNameParts2',fileNameParts)
        //         const nameWithoutExtension = fileNameParts.join('.');
        //         // console.log('fileNameParts',nameWithoutExtension)
        //         if (this.inputFileName.trim() === '') {
        //         this.inputFileName = nameWithoutExtension;
        //         }
        //         // console.log('inputFileName',this.inputFileName)
        //     } else {
        //         this.fileName = '';
        //         this.inputFileName = '';
        //         // console.log('inputFileName',this.inputFileName)
        //     }
        // },
		onDragOver() {
			this.isDragOver = true;
		},
		onDragLeave() {
			this.isDragOver = false;
		},

		onFileDrop(event:any) {
			this.isDragOver = false;
			const file = event.dataTransfer?.files?.[0];
			if (file) {
			this.applySelectedFile(file);
			}
		},
		handleFileUpload(event:any) {
			const file = event?.target?.files?.[0];
			if (file) {
			this.applySelectedFile(file);
			} else {
			this.fileName = '';
			this.inputFileName = '';
			}
		},
		applySelectedFile(file:any) {
			this.fileName = file.name;
			this.fileToUpload = file;

			const fileNameParts = file.name.split('.');
			fileNameParts.pop();
			const nameWithoutExtension = fileNameParts.join('.');
			if (this.inputFileName.trim() === '') {
			this.inputFileName = nameWithoutExtension;
			}
			// const fileExtension = file.name.split('.').pop();
			const fileExtension = file.name.split('.').pop()?.toLowerCase();
			if (
			fileExtension == 'pdf' || fileExtension == 'docx' || fileExtension == 'xls' ||
			fileExtension == 'xlsx' || fileExtension == 'jpeg' || fileExtension == 'png' ||
			fileExtension == 'jpg' || fileExtension == 'mp4' || fileExtension == 'doc' ||
			fileExtension == 'rtf' || fileExtension == 'txt' || fileExtension == 'csv' ||
			fileExtension == 'zip' || fileExtension == 'ods'
			) {
			this.pdfValidation = false;
			this.v$.$reset();
			} else {
			this.pdfValidation = true;
			}
		},
		clearSelectedFile() {
			this.fileName = '';
			this.fileToUpload = '';
			this.pdfValidation = false;
			this.v$.$reset();

			if (this.$refs.fileInput) {
				this.$refs.fileInput.value = '';
			}
		},
		async handleFileChange(event: any) {
			if (this.evidenceAttachMode === 'url') {
				await this.handleUrlEvidenceSave();
				return;
			}
			// let data = this.$refs.fileInput.files[0];
			let data = this.fileToUpload;
			// this.fileToUpload = data
			this.v$.inputFileName.$touch()
			this.v$.fileToUpload.$touch()
			this.v$.evidenceDate.$touch()
			if((!this.v$.fileToUpload.$invalid) && (!this.v$.inputFileName.$invalid) && (!this.v$.evidenceDate.$invalid) && !this.pdfValidation){
			this.clickOnButton = true;

			this.importpopUp = !this.importpopUp
			let fileExtension = data.name.split('.').pop();
			if (fileExtension == 'pdf' || fileExtension == 'docx' || fileExtension == 'xls' || fileExtension == 'xlsx' || fileExtension == 'jpeg'|| fileExtension == 'png'|| fileExtension == 'jpg' || fileExtension == 'mp4'|| fileExtension == 'doc' || fileExtension == 'rtf' || fileExtension == 'txt' || fileExtension == 'csv' || fileExtension=='zip' || fileExtension == 'ods') {
				const fileDataFormat = await this.getConvertDataForFile(data);
				let uuid = uuidv4();
				let payload = { fileData: fileDataFormat,fileType:1, name: `${uuid}.${fileExtension}` };
				// let folderName = 'finding';
				let folderName = process.env.VUE_APP_AUDIT_FOLDER_NAME;
				try {
					await this.$http
						.post(`${process.env.VUE_APP_FILE_API}/bucket/${folderName}/file/upload`, payload)
						// .post(`http://localhost:4030/services/filemanagement/bucket/${folderName}/file/upload`, payload)
						// bucket/:folderName/file/upload
						.then(async (response: any) => {
							if (response.status == 200) {
								let payload: any = {
									name: `${uuid}.${fileExtension}`,
									url: response.data,
									filename:this.inputFileName,
									evidenceDate:new Date(this.evidenceDate).toISOString(),
									fileType:1,
									evidenceType: 'file'
								};
								await this.updateFindingTask(3, payload);
								this.resetEvidenceForm();
							} else {
								// console.log('response status', response.status);
							}
						});
				} catch (err) {
					// console.error(err);
				} finally {
					this.clickOnButton = false;
				}
			} else {
				toast.error(`Upload only pdf`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}
			this.inputFileName = ''
			
			}
		},
		isEvidenceAttachDisabled() {
			return this.TaskDetailsDropDown.taskStatus == 10414 || this.TaskDetailsDropDown.taskStatus == 10403 || this.TaskDetailsDropDown.taskStatus == 10417 || this.presentAuditObject.statusCode == 10403 || this.presentAuditObject.statusCode == 10418 || this.presentFindingTaskObj.auditor == this.userInfo._id || !this.isAddDisabled(10302);
		},
		isPlannerCreatedEvidence(doc: any) {
			const plannerFolder = String(process.env.VUE_APP_PLANNER_FOLDER_NAME || '').trim();
			if (plannerFolder && String(doc?.url || '').includes(`/${plannerFolder}/`)) return true;
			const currentTaskId = String(this.presentFindingTaskObj?.taskId ?? '');
			return doc?.taskId != null && String(doc.taskId) !== '' && String(doc.taskId) !== currentTaskId;
		},
		canDeleteAuditEvidence(doc: any) {
			if (!doc) return false;
			if (doc.linkedEvidenceTaskId != null && String(doc.linkedEvidenceTaskId) !== '') return true;
			const url = String(doc?.url || '');
			const plannerFolder = String(process.env.VUE_APP_PLANNER_FOLDER_NAME || '').trim();
			const monitorFolder = String(process.env.VUE_APP_MONITOR_FOLDER_NAME || '').trim();
			if (plannerFolder && url.includes(`/${plannerFolder}/`)) return false;
			if (monitorFolder && url.includes(`/${monitorFolder}/`)) return false;
			const auditFolder = String(process.env.VUE_APP_AUDIT_FOLDER_NAME || '').trim();
			if (auditFolder && url.includes(`/${auditFolder}/`)) return true;
			const currentTaskId = String(this.presentFindingTaskObj?.taskId ?? '');
			const fileTaskId = doc?.taskId != null ? String(doc.taskId) : '';
			const sourceTaskId = doc?.linkedEvidenceTaskId
				? String(doc.linkedEvidenceTaskId)
				: (fileTaskId && fileTaskId !== currentTaskId ? fileTaskId : '');
			if (!sourceTaskId) return true;
			const prefix = (id: string) => (id.match(/^[A-Za-z]+/) || [''])[0].toUpperCase();
			return prefix(sourceTaskId) === prefix(currentTaskId);
		},
		evidenceTaskLabel(doc: any) {
			return doc?.taskId || 'N/A';
		},
		openDeleteEvidenceConfirm(evidenceIndex: number) {
			if (evidenceIndex < 0) return;
			this.deleteEvidenceIndex = evidenceIndex;
			this.showDeleteEvidenceConfirm = true;
		},
		cancelDeleteEvidence() {
			this.showDeleteEvidenceConfirm = false;
			this.deleteEvidenceIndex = null;
		},
		async confirmDeleteEvidence() {
			const evidenceIndex = this.deleteEvidenceIndex;
			this.showDeleteEvidenceConfirm = false;
			this.deleteEvidenceIndex = null;
			if (evidenceIndex == null) return;
			await this.removeEvidence(evidenceIndex);
		},
		async removeEvidence(evidenceIndex: number) {
			if (this.isEvidenceAttachDisabled()) return;
			const evidence = this.presentFindingTaskObj?.files?.[evidenceIndex];
			if (!this.canDeleteAuditEvidence(evidence)) return;
			const url = evidence?.url;
			const isUrlEvidence = evidence?.evidenceType === 'url';
			const plannerFolder = String(process.env.VUE_APP_PLANNER_FOLDER_NAME || '').trim();
			const monitorFolder = String(process.env.VUE_APP_MONITOR_FOLDER_NAME || '').trim();
			const isPlannerOrMonitorFile = [plannerFolder, monitorFolder].some((folder) => folder && String(url || '').includes(`/${folder}/`));
			try {
				let urlStillUsed = false;
				if (!isUrlEvidence && url && !isPlannerOrMonitorFile) {
					const tasksResponse = await this.$http.get(`${process.env.VUE_APP_AUDIT_API}/api/capa-tasks/getall`);
					const tasks = Array.isArray(tasksResponse?.data) ? tasksResponse.data : [];
					const currentId = String(this.currentTaskId || '');
					urlStillUsed = tasks.some((task: any) => String(task?._id || '') !== currentId && Array.isArray(task?.files) && task.files.some((doc: any) => doc?.url === url));
				}
				if (!isUrlEvidence && url && !urlStillUsed && !isPlannerOrMonitorFile) {
					const fileResponse = await this.$http.post(`${process.env.VUE_APP_FILE_API}/bucket/file/delete`, { url });
					if (!(fileResponse.status == 200 && fileResponse.data?.deleted === true)) {
						return;
					}
				}
				await this.$http.post(
					`${process.env.VUE_APP_AUDIT_API}/api/org/capa-task/${this.currentTaskId}/evidence/remove`,
					{ evidenceIndex, createdBy: this.userInfo._id }
				);
				await this.getAllFindingTasks();
				await this.getFindingTaskHistoryObject();
			} catch (err) {
				toast.error(`Failed to remove evidence`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}
		},
		async loadExistingFileOptions() {
			try {
				const [auditTaskRes, auditCapaRes, monitorTaskRes, monitorCapaRes, plannerRes] = await Promise.all([
					this.$http.get(`${process.env.VUE_APP_AUDIT_API}/api/tasks/getall`),
					this.$http.get(`${process.env.VUE_APP_AUDIT_API}/api/capa-tasks/getall`),
					this.$http.get(`${process.env.VUE_APP_MONITOR_API}/api/org/tasks/getall`),
					this.$http.get(`${process.env.VUE_APP_MONITOR_API}/capa/tasks`),
					this.$http.get(`${process.env.VUE_APP_PLANNER_API}/api/org/tasks/getAll`),
				]);
				const auditTasks = Array.isArray(auditTaskRes?.data) ? auditTaskRes.data : [];
				const auditCapaTasks = Array.isArray(auditCapaRes?.data) ? auditCapaRes.data : [];
				const monitorCrTasks = (Array.isArray(monitorTaskRes?.data) ? monitorTaskRes.data : []).filter((task: any) => task?.actionType == 20501);
				const monitorCapaTasks = Array.isArray(monitorCapaRes?.data) ? monitorCapaRes.data : [];
				const plannerTasks = (Array.isArray(plannerRes?.data) ? plannerRes.data : []).map((task: any) => ({
					...task,
					files: Array.isArray(task.evidences) ? task.evidences : task.files
				}));
				this.linkEvidenceTasks = auditTasks.concat(auditCapaTasks, monitorCrTasks, monitorCapaTasks, plannerTasks);
			} catch (error) {
				this.linkEvidenceTasks = [];
				toast.error(`Failed to load tasks`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}
		},
		resetExistingEvidenceTable() {
			this.existingEvidenceSortKey = '';
			this.existingEvidenceSortDir = 'asc';
			this.showExistingEvidenceFilters = false;
			this.existingEvidenceFilters = { filename: '', sourceTaskId: '', evidenceType: '', evidenceDate: '' };
		},
		toggleExistingEvidenceFilters() {
			this.showExistingEvidenceFilters = !this.showExistingEvidenceFilters;
			if (!this.showExistingEvidenceFilters) {
				this.existingEvidenceFilters = { filename: '', sourceTaskId: '', evidenceType: '', evidenceDate: '' };
			}
		},
		existingEvidenceTypeLabel(row: any) {
			if (row?.evidenceType === 'url') return String(row.evidenceType).toUpperCase();
			const values = [row?.name, row?.url, row?.filename];
			for (const value of values) {
				const text = String(value || '').split('?')[0];
				const ext = (text.split('.').pop() || '').toLowerCase();
				if (ext && ext !== text.toLowerCase()) return ext.toUpperCase();
			}
			return String(row?.evidenceType || 'file').toUpperCase();
		},
		sortExistingEvidence(key: string) {
			if (this.existingEvidenceSortKey === key) {
				this.existingEvidenceSortDir = this.existingEvidenceSortDir === 'asc' ? 'desc' : 'asc';
			} else {
				this.existingEvidenceSortKey = key;
				this.existingEvidenceSortDir = 'asc';
			}
		},
		openLinkEvidencePopup() {
			this.selectedExistingEvidences = [];
			this.resetExistingEvidenceTable();
			this.linkEvidencePopup = true;
			this.loadExistingFileOptions();
		},
		closeLinkEvidencePopup() {
			this.linkEvidencePopup = false;
			this.selectedExistingEvidences = [];
			this.resetExistingEvidenceTable();
		},
		isExistingEvidenceSelected(row: any) {
			return (this.selectedExistingEvidences || []).some((item: any) => item.optionKey === row.optionKey);
		},
		toggleExistingEvidence(row: any) {
			const selected = [...(this.selectedExistingEvidences || [])];
			const index = selected.findIndex((item: any) => item.optionKey === row.optionKey);
			if (index >= 0) {
				selected.splice(index, 1);
			} else {
				selected.push(row);
			}
			this.selectedExistingEvidences = selected;
		},
		async saveLinkedEvidence() {
			const docs = this.selectedExistingEvidences || [];
			const files = docs.filter((doc: any) => doc?.url).map((doc: any) => {
				const filename = doc.filename || doc.name;
				const item: any = {
					url: doc.url,
					filename,
					evidenceDate: doc.evidenceDate,
					evidenceType: doc.evidenceType || 'file'
				};
				if (doc.name) {
					item.name = doc.name;
				}
				if (doc.fileType !== undefined && doc.fileType !== null) {
					item.fileType = doc.fileType;
				}
				if (doc.sourceTaskId != null && String(doc.sourceTaskId) !== '') {
					item.linkedEvidenceTaskId = String(doc.sourceTaskId);
				}
				return item;
			});
			if (!files.length) return;
			this.linkEvidencePopup = false;
			this.selectedExistingEvidences = [];
			await this.updateFindingTask(3, { files });
		},
		async updateFindingTask(type: any, payload: any) {
			payload.createdBy = this.userInfo._id;
            payload.createdAt = moment().format('YYYY-MM-DD HH:mm:ss');
			if(type == 1){
				payload.additionalInfo = {comment:''};
				payload.additionalInfo.comment = payload.comment;
			}else if(type == 3){
				if (Array.isArray(payload.files)) {
					payload.files.forEach((item: any) => {
						item.createdBy = payload.createdBy;
						item.taskId = this.presentFindingTaskObj?.taskId;
						item.additionalInfo = { evidence: item.filename, evidenceDate: item.evidenceDate };
					});
				} else {
				payload.taskId = this.presentFindingTaskObj?.taskId
				payload.additionalInfo = {evidence:'',evidenceDate:''};
				payload.additionalInfo.evidence = payload.filename;
				payload.additionalInfo.evidenceDate=payload.evidenceDate;
				payload.fileType=payload.fileType
				}
			}else if(type == 4){
				payload.additionalInfo = {previousStatus:'',updatedStatus:''};
				payload.additionalInfo.previousStatus = this.presentFindingTaskObj.statusCode;
				payload.additionalInfo.updatedStatus = payload.statusCode;
				if (payload.statusCode==10401) this.disabledStatuses = [];
				else if (payload.statusCode==10402) this.disabledStatuses = [10401];
				else if (payload.statusCode==10408) this.disabledStatuses = [10401, 10402];
				else if(payload.statusCode == 10414 ) this.disabledStatuses = [10401,10402,10408];
				else if(payload.statusCode == 10421) this.disabledStatuses = [10401,10402,10408,10414];
				else if(payload.statusCode == 10403) this.disabledStatuses = [10401,10402,10408,10414,10421]
				else this.disabledStatuses = [];
			}else if(type == 5){
				payload.additionalInfo = {assignee:''};
				payload.additionalInfo.assignee = payload.assignee;
			}else if(type == 6){
				payload.additionalInfo = {previousStatus: payload.statusCode,updatedStatus:10421};
				// payload.additionalInfo.checkapproval = payload.checkapproval;
				payload.statusCode = payload.statusCode
			}
			else if(type == 8){
				let dueDateUpdate:any={
					previousDueDate:this.dummyPresentTaskObject.dueDate?this.dummyPresentTaskObject.dueDate:'',
					updatedDueDate:new Date(payload.dueDate)
				}
				payload.additionalInfo = dueDateUpdate
			}
			try {
				await this.$http.post(`${process.env.VUE_APP_AUDIT_API}/api/org/capa-task/${this.currentTaskId}/type/${type}/update`, payload).then(async (result: any) => {
					toast.info(`Updated`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
					});
					await this.getAllFindingTasks();
					await this.getFindingTaskHistoryObject();
					
				});
			} catch {
				toast.error(`Error`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			} finally {
				this.clickOnButtonForApproval = false;
			}
		},
		isOptionDisabled(option:any) {
			
			return this.disabledStatuses.includes(option.id);
		},
		async getConvertDataForFile(data: any) {
			return new Promise((resolve) => {
				const reader: any = new FileReader();
				reader.onload = function () {
					 resolve(reader.result);
					// resolve(reader.result.replace('data:', '').replace(/^.+,/, ''));
				};
				reader.readAsDataURL(data);
			});
		},
		 colorAuditText(status: any) {
			if (status == 10401) {
				return ['font-semibold text-disabledgrey'];
			} else if (status == 10415 || status==10421) {
				return ['font-semibold text-yellow'];
			} else if (status == 10403) {
				return ['font-semibold text-lightgreen'];
			} else if(status == 10402){
				return ['font-semibold mx-2 text-electricGreen']
			} else if(status == 10408){
				return ['font-semibold mx-2 text-primary']
			}else if(status == 10417){
				return ['font-semibold mx-2 text-darkred']
			}
		},
		colorAuditBg(status: any) {
			if (status == 10401) {
				return ['bg-lightgrey border-solid border border-disabledgrey'];
			} else if (status == 10415 || status==10421) {
				return ['bg-moderateColor border-solid border border-yellow'];
			} else if (status == 10403) {
				return ['bg-veryLowColor border-solid border border-lightgreen'];
			} else if (status == 10402) {
				return ['pendingEvidence border-solid border border-electricGreen'];
			} else if (status == 10408) {
				return ['evidenceUpload border-solid border border-primary'];
			}else if (status == 10417) {
				return ['bg-veryHighColor border-solid border border-darkred'];
			}
		},
		async getAllFindingTasks() {
			await this.$http
				.get(`${process.env.VUE_APP_AUDIT_API}/api/capa-tasks/getall`)
				.then((result: any) => {
					this.allTasks = result.data || [];

					let taskId: any = String(this.currentTaskId || '');
					let matchedTask: any = this.allTasks.find((task: any) => String(task._id) === taskId);
					
					if (matchedTask) {
						this.presentFindingTaskObj = matchedTask;
						this.dummyPresentTaskObject = matchedTask;
					} else {
						this.presentFindingTaskObj = {}; 
					}

					if (Array.isArray(this.presentFindingTaskObj.approvals) && this.presentFindingTaskObj.approvals.length > 0) {
						const lastApproval = this.presentFindingTaskObj.approvals[this.presentFindingTaskObj.approvals.length - 1];
						this.approvalObj = lastApproval;
					}
					else{
						this.approvalObj = {}
					}
					if(this.presentFindingTaskObj.dueDate!=undefined){
						this.presentFindingTaskObj.dueDate = moment(this.presentFindingTaskObj.dueDate).format('YYYY-MM-DD')
					}

                        
					this.TaskDetailsDropDown.taskStatus = this.presentFindingTaskObj.statusCode;

					if(this.presentFindingTaskObj.assignee != undefined){
						let userObj:any = this.optionsUserArray.find((obj:any)=>{return obj.value == this.presentFindingTaskObj.assignee});
						this.presentFindingTaskObj.assignee = userObj;
					}
				})
				.catch((error: any) => {
					// console.error("Error fetching tasks:", error);
				});
		}


	},
	async mounted(){
		await this.loadFindingSeverityLabelOptions();
		emitter.off('addedComments');
		emitter.on('addedComments',(data: any)=>{
			this.comment = data.comments
			this.addComment()
		})
	},
	beforeUnmount() {
		 sessionStorage.removeItem('selectedTab')
	 },
	async created() {
		const savedTabKey = sessionStorage.getItem('selectedTab');
		if (savedTabKey) {
         const savedTab = this.tabHead.find((tab: any) => tab.id == savedTabKey);
            if (savedTab) {
                this.toggleTabs(savedTab);
            }
            else{
               this.selectedTabObj = { displayName: 'Description', id: 1 };
			   this.selectedTabIndex = 1;
            }
      }
	  else{
		  this.selectedTabObj = { displayName: 'Description', id: 1 };
	   	  this.selectedTabIndex = 1;
	   }
	   this.dotsLoading=true
		try {
		await this.getCapaStatuses();
		await this.getAllActiveUsers();
		await this.getAllTeams();
		await this.getPresentFindingObject()
		await this.getAllFindingTasks();
		await this.getFindingTaskHistoryObject();
		// let taskId:any = this.currentTaskId;
		// let obj : any = this.presentFindingTaskObj.find((task: any)=>{return task._id == taskId})
		// this.presentFindingTaskObj = obj
		await this.getallEntities();
		this.findingsObjectDummy = { ...this.findingsObject };

        this.routesArray = [
            { name: 'CAPA Tasks', routeName: 'findingTask' },
			{ name: this.presentFindingTaskObj.taskId, routeName: 'findingTaskEdit' }
        ];
        this.navIndexNums = { index: 1, name: 'Description' };
		} finally {
		this.tabDataLoading=false
	   	this.dotsLoading=false
		}
		let userObj:any = this.optionsUserArray.find((user: any) => {
			return user.value == this.presentFindingTaskObj.auditee;
		});

		if (userObj == undefined) {
			this.approvalSent = {}
		} else {
			this.approvalSent = userObj;
		}

		// if(this.presentFindingTaskObj.comments != undefined){
		// 	this.presentFindingTaskObj.comments;
		// }

		if(this.presentFindingTaskObj.assignee != undefined){
            this.newTeamAssignee = this.presentFindingTaskObj.assignee
        }
		if (this.presentFindingTaskObj.statusCode==10401) this.disabledStatuses = [];
          else if (this.presentFindingTaskObj.statusCode==10402) this.disabledStatuses = [10401];
          else if (this.presentFindingTaskObj.statusCode==10408) this.disabledStatuses = [10401, 10402];
          else if(this.presentFindingTaskObj.statusCode == 10414 ) this.disabledStatuses = [10401,10402,10408];
          else if(this.presentFindingTaskObj.statusCode == 10421) this.disabledStatuses = [10401,10402,10408,10414];
          else if(this.presentFindingTaskObj.statusCode == 10403) this.disabledStatuses = [10401,10402,10408,10414,10421]
          else this.disabledStatuses = [];
	}
});
</script>